// // import React, { useState, useEffect, useRef } from "react";
// // import axios from "axios";
// // import { ToastContainer, toast } from "react-toastify";
// // import "react-toastify/dist/ReactToastify.css";
// // import "./Booking.css";
// // import { apiWithLog } from "../utils/apiWithLog";

// // const Booking = () => {
// //   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
// //   const today = new Date().toISOString().split("T")[0];

// //   const [selectedDate, setSelectedDate] = useState(today);
// //   const [selectedCompanyId, setSelectedCompanyId] = useState(null);
// //   const lastCompanyId = useRef(null);

// //   const [bookingList, setBookingList] = useState([]);
// //   const [isLoadingBookings, setIsLoadingBookings] = useState(false);

// //   const [parties, setParties] = useState([]);
// //   const [vehicles, setVehicles] = useState([]);

// //   const [showAddModal, setShowAddModal] = useState(false);
// //   const [showEditModal, setShowEditModal] = useState(false);

// //   // ===== DELETE MODAL STATE =====
// //   const [showDeleteModal, setShowDeleteModal] = useState(false);
// //   const [deleteId, setDeleteId] = useState(null);

// //   const [editId, setEditId] = useState(null);
// //   const [isSaving, setIsSaving] = useState(false);
// //   const [isEndManual, setIsEndManual] = useState(false);

// //   const [showDutySlipModal, setShowDutySlipModal] = useState(false);
// //   const [isDutySlipReadOnly, setIsDutySlipReadOnly] = useState(false);
// //   const [selectedBooking, setSelectedBooking] = useState(null);

// //   const [kmError, setKmError] = useState("");

// //   // ================= TIME STATE =================
// //   const [timeParts, setTimeParts] = useState({ hh: "12", mm: "00", ap: "AM" });
// //   const [endTimeParts, setEndTimeParts] = useState({
// //     hh: "08",
// //     mm: "00",
// //     ap: "AM",
// //   });

// //   const [booking, setBooking] = useState({
// //     bookingDate: today,
// //     endBookingDate: today,
// //     time: "00:00:00",
// //     endTime: "08:00:00",
// //     partyName: "",
// //     address: "",
// //     mobile: "",
// //     vehicleType: "",
// //     guestName: "",
// //     bookedBy: "",
// //   });

// //   // ================= COMPANY =================
// //   const getCompanyId = () => {
// //     try {
// //       const company = JSON.parse(localStorage.getItem("selectedCompany"));
// //       return company?.id || null;
// //     } catch {
// //       return null;
// //     }
// //   };

// //   useEffect(() => {
// //     const interval = setInterval(() => {
// //       const id = getCompanyId();
// //       if (id !== lastCompanyId.current) {
// //         lastCompanyId.current = id;
// //         setSelectedCompanyId(id);
// //       }
// //     }, 500);

// //     return () => clearInterval(interval);
// //   }, []);

// //   // ================= DROPDOWNS =================
// //   useEffect(() => {
// //     if (!selectedCompanyId) return;

// //     axios
// //       .get(`${BASE_API_URL}/invoice/dropdowns/${selectedCompanyId}`)
// //       .then((res) => {
// //         if (res.data?.success) setParties(res.data.data || []);
// //       });

// //     axios
// //       .get(`${BASE_API_URL}/invoice/vehicles/${selectedCompanyId}`)
// //       .then((res) => {
// //         if (res.data?.success) setVehicles(res.data.data || []);
// //       });
// //   }, [selectedCompanyId]);

// //   // ================= TIME HELPERS =================
// //   const buildTime24 = (parts) => {
// //     let h = parseInt(parts.hh, 10);
// //     if (parts.ap === "AM") {
// //       if (h === 12) h = 0;
// //     } else {
// //       if (h !== 12) h += 12;
// //     }
// //     return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
// //   };

// //   const autoCalculateEnd = (date, time) => {
// //     if (isEndManual) return;
// //     if (!date || !time) return;

// //     // Create LOCAL date object
// //     const [year, month, day] = date.split("-");
// //     const [hour, minute, second] = time.split(":");

// //     const start = new Date(
// //       Number(year),
// //       Number(month) - 1,
// //       Number(day),
// //       Number(hour),
// //       Number(minute),
// //       Number(second || 0),
// //     );

// //     // Add fixed 8 hours
// //     start.setHours(start.getHours() + 8);

// //     // ===== LOCAL DATE (not ISO) =====
// //     const endYear = start.getFullYear();
// //     const endMonth = String(start.getMonth() + 1).padStart(2, "0");
// //     const endDay = String(start.getDate()).padStart(2, "0");

// //     const endDate = `${endYear}-${endMonth}-${endDay}`;

// //     // ===== TIME =====
// //     const hour24 = start.getHours();
// //     const minuteLocal = start.getMinutes();

// //     let hh12 = hour24 % 12;
// //     if (hh12 === 0) hh12 = 12;

// //     const ap = hour24 >= 12 ? "PM" : "AM";

// //     const hhStr = String(hh12).padStart(2, "0");
// //     const mmStr = String(minuteLocal).padStart(2, "0");

// //     // Update booking (24h format)
// //     setBooking((prev) => ({
// //       ...prev,
// //       endBookingDate: endDate,
// //       endTime: `${String(hour24).padStart(2, "0")}:${mmStr}:00`,
// //     }));

// //     // Update dropdown (12h format)
// //     setEndTimeParts({
// //       hh: hhStr,
// //       mm: mmStr,
// //       ap,
// //     });
// //   };

// //   // ================= TIME CHANGE =================
// //   const updateTime = (key, value) => {
// //     const v = key === "ap" ? value : String(value).padStart(2, "0");

// //     setTimeParts((prev) => {
// //       const updated = { ...prev, [key]: v };
// //       const time24 = buildTime24(updated);

// //       setBooking((p) => {
// //         autoCalculateEnd(p.bookingDate, time24);
// //         return { ...p, time: time24 };
// //       });

// //       return updated;
// //     });
// //   };

// //   const updateEndTime = (key, value) => {
// //     setIsEndManual(true);

// //     const v = key === "ap" ? value : String(value).padStart(2, "0");

// //     setEndTimeParts((prev) => {
// //       const updated = { ...prev, [key]: v };
// //       const time24 = buildTime24(updated);

// //       setBooking((p) => ({ ...p, endTime: time24 }));
// //       return updated;
// //     });
// //   };

// //   const handleChange = (e) => {
// //     const { name, value } = e.target;

// //     setBooking((prev) => {
// //       const updated = { ...prev, [name]: value };

// //       if (name === "bookingDate") {
// //         autoCalculateEnd(value, updated.time);
// //       }

// //       if (name === "endBookingDate") {
// //         setIsEndManual(true);
// //       }

// //       return updated;
// //     });
// //   };

// //   // ================= PARTY AUTO FILL =================
// //   const handlePartySelect = async (e) => {
// //     const name = e.target.value;

// //     setBooking((p) => ({
// //       ...p,
// //       partyName: name,
// //       address: "",
// //       mobile: "",
// //     }));

// //     if (!name || !selectedCompanyId) return;

// //     const res = await axios.get(
// //       `${BASE_API_URL}/invoice/dropdowns/details/${selectedCompanyId}?headName=${encodeURIComponent(
// //         name,
// //       )}`,
// //     );

// //     if (res.data?.success) {
// //       const p = res.data.data || {};
// //       setBooking((prev) => ({
// //         ...prev,
// //         address: p.ADDRESS1 || "",
// //         mobile: p.MOBILE || "",
// //       }));
// //     }
// //   };

// //   const fetchBookings = async (compId, date) => {
// //     console.log("fetchBookings:", compId, date);

// //     if (!compId) {
// //       console.log("No CompID, API not called");
// //       return;
// //     }

// //     try {
// //       setIsLoadingBookings(true);

// //       const url = `${BASE_API_URL}/bookings/${compId}?date=${date}`;
// //       console.log("API URL:", url);

// //       const res = await axios.get(url);
// //       console.log("API Response:", res.data);

// //       const data = res.data?.data || res.data || [];

// //       const records = data.map((row) => ({
// //         id: row.BookingID,
// //         bookingDate: row.BookingDate
// //           ? String(row.BookingDate).split("T")[0]
// //           : "",
// //         time: row.time24 || "00:00:00",
// //         time12: row.time12 || "",
// //         endBookingDate: row.BookingEndDate
// //           ? String(row.BookingEndDate).split("T")[0]
// //           : "",
// //         endTime: row.endTime24 || "00:00:00",
// //         endTime12: row.endTime12 || "",
// //         partyName: row.PartyName || "",
// //         address: row.ClientAddress || "",
// //         mobile: row.Mobile || "",
// //         vehicleType: row.CarType || "",
// //         guestName: row.ClientName || "",
// //         bookedBy: row.Detail || "",
// //         companyId: row.CompID,
// //         dutyslipId: row.DutyslipID || null,
// //       }));

// //       setBookingList(records);
// //     } catch (err) {
// //       console.log("Fetch Booking Error:", err);
// //       toast.error("Failed to fetch bookings");
// //       setBookingList([]);
// //     } finally {
// //       setIsLoadingBookings(false);
// //     }
// //   };

// //   useEffect(() => {
// //     if (selectedCompanyId) {
// //       fetchBookings(selectedCompanyId, selectedDate);
// //     }
// //   }, [selectedCompanyId, selectedDate]);

// //   // ================= SAVE =================
// //   const saveBooking = async () => {
// //     if (!validateBookingForm()) return;

// //     try {
// //       setIsSaving(true);

// //       const payload = {
// //         bookingDate: booking.bookingDate,
// //         time: buildTime24(timeParts),

// //         bookingEndDate: booking.endBookingDate,
// //         bookingEndTime: booking.endTime,

// //         partyName: booking.partyName,
// //         clientAddress: booking.address,
// //         mobile: booking.mobile,
// //         carType: booking.vehicleType,
// //         clientName: booking.guestName,
// //         detail: booking.bookedBy,

// //         compId: selectedCompanyId,
// //       };
// //       const res = await apiWithLog({
// //         method: "POST",
// //         url: `${BASE_API_URL}/bookings/create`,
// //         data: payload,
// //         module: "Booking",
// //         action: "A",
// //       });

// //       console.log("✅ Booking API Response:", res);
// //       console.log("✅ Booking Data:", res.data);

// //       if (res.data?.success) {
// //         toast.success("Booking Saved");

// //         setShowAddModal(false);
// //         fetchBookings(selectedCompanyId, selectedDate);
// //       } else {
// //         toast.error("Save failed");
// //       }
// //     } catch (err) {
// //       toast.error("Server error");
// //     } finally {
// //       setIsSaving(false);
// //     }
// //   };

// //   const updateBooking = async () => {
// //     if (!validateBookingForm()) return;

// //     if (!editId) {
// //       toast.error("Booking ID missing");
// //       return;
// //     }

// //     try {
// //       setIsSaving(true);

// //       const payload = {
// //         bookingDate: booking.bookingDate,
// //         time: buildTime24(timeParts),
// //         bookingEndDate: booking.endBookingDate,
// //         bookingEndTime: booking.endTime,
// //         partyName: booking.partyName,
// //         clientAddress: booking.address,
// //         mobile: booking.mobile,
// //         carType: booking.vehicleType,
// //         clientName: booking.guestName,
// //         detail: booking.bookedBy,
// //         compId: selectedCompanyId,
// //       };

// //       // const res = await axios.put(
// //       //   `${BASE_API_URL}/bookings/update/${editId}`,
// //       //   payload,
// //       // );

// //       const res = await apiWithLog({
// //         method: "PUT",
// //         url: `${BASE_API_URL}/bookings/update/${editId}`,
// //         data: payload,
// //         module: "Booking",
// //         action: "E",
// //       });

// //       if (res.data?.success) {
// //         toast.success("Booking updated");
// //         setShowEditModal(false);

// //         // reload same date data
// //         fetchBookings(selectedCompanyId, selectedDate);
// //       } else {
// //         toast.error("Update failed");
// //       }
// //     } catch (err) {
// //       toast.error("Server error");
// //     } finally {
// //       setIsSaving(false);
// //     }
// //   };

// //   // Open delete popup
// //   const openDeleteModal = (id) => {
// //     setDeleteId(id);
// //     setShowDeleteModal(true);
// //   };

// //   // Confirm delete
// //   const confirmDeleteBooking = async () => {
// //     try {
// //       // await axios.delete(`${BASE_API_URL}/bookings/delete/${deleteId}`);

// //       const res = await apiWithLog({
// //         method: "DELETE",
// //         url: `${BASE_API_URL}/bookings/delete/${deleteId}`,
// //         module: "Booking",
// //         action: "D",
// //       });

// //       toast.success("Booking deleted");

// //       setShowDeleteModal(false);
// //       setDeleteId(null);

// //       fetchBookings(selectedCompanyId, selectedDate);
// //     } catch (err) {
// //       toast.error("Delete failed");
// //     }
// //   };

// //   const openNewBooking = () => {
// //     setEditId(null);
// //     setIsEndManual(false);

// //     // Reset time dropdown
// //     setTimeParts({
// //       hh: "12",
// //       mm: "00",
// //       ap: "AM",
// //     });

// //     // Reset end time dropdown
// //     setEndTimeParts({
// //       hh: "08",
// //       mm: "00",
// //       ap: "AM",
// //     });

// //     // Reset form
// //     const startTime = "00:00:00";

// //     setBooking({
// //       bookingDate: today,
// //       endBookingDate: today,
// //       time: startTime,
// //       endTime: "08:00:00",
// //       partyName: "",
// //       address: "",
// //       mobile: "",
// //       vehicleType: "",
// //       guestName: "",
// //       bookedBy: "",
// //     });

// //     // Auto calculate end time again
// //     autoCalculateEnd(today, startTime);

// //     setShowAddModal(true);
// //   };

// //   const openEditBooking = (b) => {
// //     setEditId(b.id);

// //     // Allow auto end recalculation
// //     setIsEndManual(false);

// //     const bookingDate = b.bookingDate || today;
// //     const endBookingDate = b.endBookingDate || bookingDate;

// //     const startTime = b.time || "00:00:00";
// //     const endTime = b.endTime || "08:00:00";

// //     // Start time dropdown
// //     const [sh, sm] = startTime.split(":");
// //     let sh12 = parseInt(sh, 10);
// //     let sap = "AM";

// //     if (sh12 === 0) sh12 = 12;
// //     else if (sh12 === 12) sap = "PM";
// //     else if (sh12 > 12) {
// //       sh12 -= 12;
// //       sap = "PM";
// //     }

// //     setTimeParts({
// //       hh: String(sh12).padStart(2, "0"),
// //       mm: sm,
// //       ap: sap,
// //     });

// //     // End time dropdown
// //     const [eh, em] = endTime.split(":");
// //     let eh12 = parseInt(eh, 10);
// //     let eap = "AM";

// //     if (eh12 === 0) eh12 = 12;
// //     else if (eh12 === 12) eap = "PM";
// //     else if (eh12 > 12) {
// //       eh12 -= 12;
// //       eap = "PM";
// //     }

// //     setEndTimeParts({
// //       hh: String(eh12).padStart(2, "0"),
// //       mm: em,
// //       ap: eap,
// //     });

// //     setBooking({
// //       bookingDate,
// //       endBookingDate,
// //       time: startTime,
// //       endTime,
// //       partyName: b.partyName || b.PartyName || "",
// //       address: b.address || "",
// //       mobile: b.mobile || "",
// //       vehicleType: b.vehicleType || "",
// //       guestName: b.guestName || "",
// //       bookedBy: b.bookedBy || "",
// //     });

// //     setShowEditModal(true);
// //   };

// //   const filteredBookings = bookingList;

// //   const [dutyslip, setDutyslip] = useState({
// //     slipDate: today,
// //     partyName: "",
// //     address: "",
// //     clientName: "",
// //     clientAddress: "",
// //     clientMobile: "",
// //     vehicleType: "",
// //     acType: "",
// //     driverName: "",
// //     kmStart: "",
// //     kmEnd: "",
// //     totalKm: "",
// //     openDate: today,
// //     closeDate: today,
// //     totalTime: "",
// //     bookingId: null,
// //   });

// //   const [errors, setErrors] = useState({});

// //   const [openTimeParts, setOpenTimeParts] = useState({
// //     hh: "09",
// //     mm: "00",
// //     ap: "AM",
// //   });

// //   const [closeTimeParts, setCloseTimeParts] = useState({
// //     hh: "05",
// //     mm: "00",
// //     ap: "PM",
// //   });

// //   const buildTime24FromParts = (parts) => {
// //     let h = parseInt(parts.hh, 10);

// //     if (parts.ap === "AM") {
// //       if (h === 12) h = 0;
// //     } else {
// //       if (h !== 12) h += 12;
// //     }

// //     return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
// //   };

// //   const buildDateTime = (date, parts) => {
// //     const time = buildTime24FromParts(parts);
// //     return `${date} ${time}`;
// //   };

// //   const getCurrentISTDateTime = () => {
// //     const now = new Date();

// //     const year = now.getFullYear();
// //     const month = String(now.getMonth() + 1).padStart(2, "0");
// //     const day = String(now.getDate()).padStart(2, "0");

// //     const hours = String(now.getHours()).padStart(2, "0");
// //     const minutes = String(now.getMinutes()).padStart(2, "0");
// //     const seconds = String(now.getSeconds()).padStart(2, "0");

// //     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
// //   };

// //   const parseTimeParts = (timeStr) => {
// //     if (!timeStr) return { hh: "12", mm: "00", ap: "AM" };
// //     const [hStr, mStr] = timeStr.split(":");
// //     let h = parseInt(hStr, 10) || 0;
// //     const mm = String(parseInt(mStr, 10) || 0).padStart(2, "0");
// //     let ap = "AM";

// //     if (h === 0) {
// //       h = 12;
// //     } else if (h === 12) {
// //       ap = "PM";
// //     } else if (h > 12) {
// //       h -= 12;
// //       ap = "PM";
// //     }

// //     const hh = String(h).padStart(2, "0");
// //     return { hh, mm, ap };
// //   };

// //   const parseDateTime = (dateStr, timeStr) => {
// //     if (!dateStr || !timeStr) return new Date(NaN);
// //     let year, month, day;
// //     const cleanDate = dateStr.trim().split(" ")[0].split("T")[0];
// //     if (cleanDate.includes("-")) {
// //       const parts = cleanDate.split("-");
// //       if (parts[0].length === 4) {
// //         [year, month, day] = parts;
// //       } else {
// //         [day, month, year] = parts;
// //       }
// //     } else if (cleanDate.includes("/")) {
// //       const parts = cleanDate.split("/");
// //       if (parts[0].length === 4) {
// //         [year, month, day] = parts;
// //       } else {
// //         [day, month, year] = parts;
// //       }
// //     } else {
// //       return new Date(cleanDate);
// //     }

// //     const [h, m, s] = timeStr.split(":");
// //     return new Date(
// //       Number(year),
// //       Number(month) - 1,
// //       Number(day),
// //       Number(h || 0),
// //       Number(m || 0),
// //       Number(s || 0)
// //     );
// //   };

// //   const calculateTotalTime = (openDate, openParts, closeDate, closeParts) => {
// //     if (!openDate || !closeDate) return;

// //     const openTime = buildTime24FromParts(openParts);
// //     const closeTime = buildTime24FromParts(closeParts);

// //     const open = parseDateTime(openDate, openTime);
// //     const close = parseDateTime(closeDate, closeTime);

// //     const diffMs = close - open;

// //     if (diffMs <= 0 || isNaN(diffMs)) {
// //       setDutyslip((prev) => ({ ...prev, totalTime: "" }));
// //       return;
// //     }

// //     const hours = Math.floor(diffMs / (1000 * 60 * 60));
// //     const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

// //     setDutyslip((prev) => ({
// //       ...prev,
// //       totalTime: `${hours}h ${minutes}m`,
// //     }));
// //   };

// //   // ===== Open Time
// //   const updateOpenTime = (key, value) => {
// //     const v = key === "ap" ? value : String(value).padStart(2, "0");

// //     setOpenTimeParts((prev) => {
// //       const updated = { ...prev, [key]: v };

// //       calculateTotalTime(
// //         dutyslip.openDate,
// //         updated,
// //         dutyslip.closeDate,
// //         closeTimeParts,
// //       );

// //       return updated;
// //     });
// //   };

// //   // ===== Close Time
// //   const updateCloseTime = (key, value) => {
// //     const v = key === "ap" ? value : String(value).padStart(2, "0");

// //     setCloseTimeParts((prev) => {
// //       const updated = { ...prev, [key]: v };

// //       calculateTotalTime(
// //         dutyslip.openDate,
// //         openTimeParts,
// //         dutyslip.closeDate,
// //         updated,
// //       );

// //       return updated;
// //     });
// //   };

// //   const handleDutySlipChange = (e) => {
// //     const { name, value } = e.target;

// //     setDutyslip((prev) => {
// //       const updated = { ...prev, [name]: value };

// //       // ===== Recalculate totalTime on date change
// //       if (name === "openDate" || name === "closeDate") {
// //         calculateTotalTime(
// //           name === "openDate" ? value : updated.openDate,
// //           openTimeParts,
// //           name === "closeDate" ? value : updated.closeDate,
// //           closeTimeParts
// //         );
// //       }

// //       // ===== Auto Total KM (Added)
// //       if (name === "kmStart" || name === "kmEnd") {
// //         const start = parseFloat(updated.kmStart) || 0;
// //         const end = parseFloat(updated.kmEnd) || 0;

// //         if (updated.kmEnd === "" || updated.kmStart === "") {
// //           updated.totalKm = "";
// //           setErrors((prev) => ({ ...prev, km: "" }));
// //         }
// //         // If End < Start → show error
// //         else if (end < start) {
// //           updated.totalKm = "";
// //           setErrors((prev) => ({
// //             ...prev,
// //             km: "KM Close cannot be less than KM Start",
// //           }));
// //         }
// //         // Valid case → calculate total
// //         else {
// //           updated.totalKm = end - start;
// //           setErrors((prev) => ({ ...prev, km: "" }));
// //         }
// //       }

// //       return updated;
// //     });
// //   };
// //   const validateForm = () => {
// //     if (
// //       !dutyslip.clientName?.trim() ||
// //       !dutyslip.clientMobile?.trim() ||
// //       !dutyslip.vehicleType ||
// //       !dutyslip.acType ||
// //       !dutyslip.driverName?.trim() ||
// //       !dutyslip.kmStart ||
// //       !dutyslip.kmEnd ||
// //       !dutyslip.totalTime
// //     ) {
// //       toast.error("All fields are required");
// //       return false;
// //     }

// //     if (!/^\d{10}$/.test(dutyslip.clientMobile)) {
// //       toast.error("Enter valid 10 digit mobile");
// //       return false;
// //     }

// //     if (Number(dutyslip.kmEnd) < Number(dutyslip.kmStart)) {
// //       toast.error("KM Close cannot be less than KM Start");
// //       return false;
// //     }

// //     return true;
// //   };

// //   const validateBookingForm = () => {
// //     if (
// //       !booking.partyName ||
// //       !booking.address ||
// //       !booking.mobile ||
// //       !booking.vehicleType ||
// //       !booking.guestName ||
// //       !booking.bookedBy ||
// //       !booking.bookingDate ||
// //       !booking.endBookingDate
// //     ) {
// //       toast.error("All fields are required");
// //       return false;
// //     }

// //     if (!/^\d{10}$/.test(booking.mobile)) {
// //       toast.error("Enter valid 10 digit mobile");
// //       return false;
// //     }

// //     return true;
// //   };
// //   const openDutySlipModal = async (booking) => {
// //     // Save selected booking
// //     setSelectedBooking(booking);

// //     // Clear errors
// //     setErrors({});

// //     if (booking.dutyslipId) {
// //       // If duty slip already exists, fetch it and display as read-only
// //       setIsDutySlipReadOnly(true);
// //       try {
// //         const res = await axios.get(`${BASE_API_URL}/dutyslip/dutyslip?id=${booking.dutyslipId}`);
// //         if (res.data?.success && res.data.data?.length > 0) {
// //           const ds = res.data.data[0];
          
// //           const slipDate = ds.DutyslipDate ? String(ds.DutyslipDate).split("T")[0] : today;
// //           const openDate = ds.DutyslipDate ? String(ds.DutyslipDate).split("T")[0] : today;
// //           const closeDate = ds.DutyslipEndDate ? String(ds.DutyslipEndDate).split("T")[0] : today;

// //           const splitTime = (time) => {
// //             if (!time) return { hh: "12", mm: "00", ap: "AM" };
// //             let [h, m] = time.split(":");
// //             h = parseInt(h, 10);
// //             let ap = "AM";
// //             if (h >= 12) {
// //               ap = "PM";
// //               if (h > 12) h -= 12;
// //             }
// //             if (h === 0) h = 12;
// //             return {
// //               hh: String(h).padStart(2, "0"),
// //               mm: m || "00",
// //               ap,
// //             };
// //           };

// //           const openParts = splitTime(ds.time24);
// //           const closeParts = splitTime(ds.endTime24);

// //           setOpenTimeParts(openParts);
// //           setCloseTimeParts(closeParts);

// //           setDutyslip({
// //             slipDate,
// //             openDate,
// //             closeDate,
// //             totalTime: ds.TotalTime ? `${ds.TotalTime}h` : "",
// //             partyName: ds.PartyName || booking.partyName || "",
// //             address: ds.PartyAddress || booking.address || "",
// //             clientName: ds.ClientName || booking.guestName || "",
// //             clientAddress: ds.ClientAddress || booking.address || "",
// //             clientMobile: ds.Mobile || booking.mobile || "",
// //             vehicleType: ds.VehicleType || booking.vehicleType || "",
// //             acType: ds.CarType || "AC",
// //             driverName: ds.DriverName || "",
// //             kmStart: ds.KMStart ?? "",
// //             kmEnd: ds.KMClose ?? "",
// //             totalKm: ds.TotalKM ?? "",
// //             bookingId: booking.id || booking.BookingID || null,
// //           });

// //           setShowDutySlipModal(true);
// //         } else {
// //           toast.error("Failed to load duty slip details");
// //         }
// //       } catch (err) {
// //         console.error("Error loading duty slip:", err);
// //         toast.error("Error loading duty slip details");
// //       }
// //     } else {
// //       // If no duty slip, prepare for generating one (editable mode)
// //       setIsDutySlipReadOnly(false);

// //       const openDate = booking.bookingDate || today;
// //       const closeDate = booking.endBookingDate || booking.bookingDate || today;

// //       // Parse time parts from booking time/endTime
// //       const openParts = parseTimeParts(booking.time);
// //       const closeParts = parseTimeParts(booking.endTime);

// //       setOpenTimeParts(openParts);
// //       setCloseTimeParts(closeParts);

// //       // Calculate initial total time
// //       const openTime24 = buildTime24FromParts(openParts);
// //       const closeTime24 = buildTime24FromParts(closeParts);

// //       const open = parseDateTime(openDate, openTime24);
// //       const close = parseDateTime(closeDate, closeTime24);
// //       const diffMs = close - open;
// //       let initialTotalTime = "";
// //       if (diffMs > 0 && !isNaN(diffMs)) {
// //         const hours = Math.floor(diffMs / (1000 * 60 * 60));
// //         const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
// //         initialTotalTime = `${hours}h ${minutes}m`;
// //       }

// //       // Fill DutySlip form with booking data
// //       setDutyslip({
// //         slipDate: today,

// //         partyName: booking.partyName || "",
// //         address: booking.address || "",
// //         clientName: booking.guestName || booking.clientName || "",
// //         clientAddress: booking.address || "",
// //         clientMobile: booking.mobile || "",

// //         vehicleType: booking.vehicleType || "",
// //         acType: "",

// //         driverName: "",
// //         kmStart: "",
// //         kmEnd: "",
// //         totalKm: "",

// //         openDate,
// //         closeDate,

// //         totalTime: initialTotalTime,

// //         // ✅ IMPORTANT – BookingId set here
// //         bookingId: booking.id || booking.BookingID || null,
// //       });

// //       // Open modal
// //       setShowDutySlipModal(true);
// //     }
// //   };

// //   const saveDutyslip = async () => {
// //     if (!validateForm()) return;

// //     try {
// //       setIsSaving(true);

// //       const openTime = `${dutyslip.openDate} ${buildTime24FromParts(openTimeParts)}`;
// //       const closeTime = `${dutyslip.closeDate} ${buildTime24FromParts(closeTimeParts)}`;

// //       // ===== Current IST SlipDate (Added)
// //       const slipDate = getCurrentISTDateTime();

// //       // Convert totalTime string "8h 30m" to float 8.5
// //       let totalTimeFloat = 0;
// //       if (dutyslip.totalTime) {
// //         const match = dutyslip.totalTime.match(/(\d+)h\s*(\d*)m?/);
// //         if (match) {
// //           const h = parseInt(match[1], 10) || 0;
// //           const m = parseInt(match[2], 10) || 0;
// //           totalTimeFloat = h + (m / 60);
// //         }
// //       }

// //       const payload = {
// //         slipDate,
// //         partyName: dutyslip.partyName,
// //         clientName: dutyslip.clientName,
// //         clientAddress: dutyslip.clientAddress || dutyslip.address || "",
// //         clientMobile: dutyslip.clientMobile,
// //         vehicleType: dutyslip.vehicleType,
// //         carType: dutyslip.acType,
// //         driverName: dutyslip.driverName,
// //         kmStart: Number(dutyslip.kmStart),
// //         kmEnd: Number(dutyslip.kmEnd),
// //         totalKm: Number(dutyslip.totalKm),
// //         openTime,
// //         closeTime,
// //         totalTime: totalTimeFloat,
// //         bookingId: dutyslip.bookingId || null,
// //         compId: selectedCompanyId,
// //       };

// //       // const res = await axios.post(
// //       //   "http://localhost:5000/api/dutyslip/create",
// //       //   payload,
// //       // );

// //       const res = await apiWithLog({
// //         method: "POST",
// //         // url: `${BASE_API_URL}/dutyslip/create`,
// //         url: "http://localhost:5000/api/dutyslip/create",
// //         data: payload,
// //         module: "Generate DutySlip",
// //         action: "A",
// //       });

// //       if (res.data?.success) {
// //         toast.success("Duty Slip Saved");
// //         const newDutyslipId = res.data.id;
        
// //         // Update local bookingList state
// //         setBookingList((prevList) =>
// //           prevList.map((b) =>
// //             b.id === dutyslip.bookingId ? { ...b, dutyslipId: newDutyslipId } : b
// //           )
// //         );

// //         // Switch to read-only view
// //         setIsDutySlipReadOnly(true);
// //       } else {
// //         toast.error(res.data.message);
// //       }
// //     } catch (err) {
// //       toast.error("Server error");
// //     } finally {
// //       setIsSaving(false);
// //     }
// //   };

// //   return (
// //     <div className="booking_container">
// //       <ToastContainer autoClose={2000} />

// //       {/* TOP BAR */}
// //       <div className="booking_top">
// //         <div className="booking_date_inline">
// //           <span className="booking_date_label">Booking Date</span>
// //           <input
// //             type="date"
// //             className="booking_date_input"
// //             value={selectedDate}
// //             onChange={(e) => setSelectedDate(e.target.value)}
// //           />
// //         </div>

// //         <button className="new_booking_btn" onClick={openNewBooking}>
// //           New Booking
// //         </button>
// //       </div>

// //       {/* BOOKING LIST */}
// //       <div className="booking_list_section">
// //         <h6>
// //           Booking List{" "}
// //           {isLoadingBookings && (
// //             <span style={{ fontSize: "12px", color: "#666" }}>
// //               (Loading...)
// //             </span>
// //           )}
// //         </h6>

// //         <table className="booking_table">
// //           <thead>
// //             <tr>
// //               <th>Party</th>
// //               <th>Guest Name</th>
// //               <th>Guest Mobile No</th>
// //               <th>Vehicle</th>
// //               <th>Booked By</th>
// //               <th>Start Time</th>
// //               <th>End Date</th>
// //               <th>End Time</th>
// //               <th>Action</th>
// //             </tr>
// //           </thead>

// //           <tbody>
// //             {filteredBookings.length === 0 ? (
// //               <tr>
// //                 <td colSpan="9" className="no_data">
// //                   No bookings found
// //                 </td>
// //               </tr>
// //             ) : (
// //               filteredBookings.map((b) => (
// //                 <tr key={b.id}>
// //                   <td>{b.partyName}</td>
// //                   <td>{b.guestName}</td>
// //                   <td>{b.mobile}</td>
// //                   <td>{b.vehicleType}</td>
// //                   <td>{b.bookedBy}</td>
// //                   <td>{b.time12 || "-"}</td>
// //                   <td>{b.endBookingDate || "-"}</td>
// //                   <td>{b.endTime12 || "-"}</td>

// //                   <td className="action_cell">
// //                     <button
// //                       className="action_btn edit_btn"
// //                       onClick={() => openEditBooking(b)}
// //                     >
// //                       Edit
// //                     </button>
// //                     <button
// //                       className="action_btn delete_btn"
// //                       onClick={() => openDeleteModal(b.id)}
// //                     >
// //                       Delete
// //                     </button>

// //                     <button
// //                       className="action_btn"
// //                       style={{ background: "#198754", color: "#fff" }}
// //                       onClick={() => openDutySlipModal(b)}
// //                     >
// //                       Duty Slip
// //                     </button>
// //                   </td>
// //                 </tr>
// //               ))
// //             )}
// //           </tbody>
// //         </table>
// //       </div>

// //       {/* ===== DELETE CONFIRM MODAL ===== */}
// //       {showDeleteModal && (
// //         <div className="delete_modal_overlay">
// //           <div className="delete_modal_box">
// //             <span
// //               className="delete_close"
// //               onClick={() => setShowDeleteModal(false)}
// //             >
// //               ✕
// //             </span>

// //             <div className="delete_icon">
// //               <span className="delete_svg_icon">🗑️</span>
// //             </div>

// //             <div className="delete_title">Delete Booking?</div>

// //             <div className="delete_text">
// //               Are you sure you want to delete this booking?
// //             </div>

// //             <div className="delete_actions">
// //               <button
// //                 className="delete_cancel_btn"
// //                 onClick={() => setShowDeleteModal(false)}
// //               >
// //                 Cancel
// //               </button>

// //               <button
// //                 className="delete_confirm_btn"
// //                 onClick={confirmDeleteBooking}
// //               >
// //                 Confirm
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ================= ADD MODAL ================= */}
// //       {showAddModal && (
// //         <div className="booking_modal">
// //           <div className="booking_modal_content">
// //             <div className="modal_header">
// //               <h5>New Booking</h5>
// //               <span
// //                 className="close_btn"
// //                 onClick={() => setShowAddModal(false)}
// //               >
// //                 ✕
// //               </span>
// //             </div>

// //             <div className="booking_form_scroll">
// //               {/* START */}
// //               <div className="booking_row">
// //                 <div className="booking_input_div">
// //                   <label>Booking Start Date</label>
// //                   <input
// //                     type="date"
// //                     name="bookingDate"
// //                     value={booking.bookingDate}
// //                     onChange={handleChange}
// //                   />
// //                 </div>

// //                 <div className="booking_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={timeParts.hh}
// //                       onChange={(e) => updateTime("hh", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i + 1).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={timeParts.mm}
// //                       onChange={(e) => updateTime("mm", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i * 5).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={timeParts.ap}
// //                       onChange={(e) => updateTime("ap", e.target.value)}
// //                     >
// //                       <option value="AM">AM</option>
// //                       <option value="PM">PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* END */}
// //               <div className="booking_row">
// //                 <div className="booking_input_div">
// //                   <label>Booking End Date</label>
// //                   <input
// //                     type="date"
// //                     name="endBookingDate"
// //                     value={booking.endBookingDate}
// //                     onChange={handleChange}
// //                   />
// //                 </div>

// //                 <div className="booking_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={endTimeParts.hh}
// //                       onChange={(e) => updateEndTime("hh", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i + 1).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={endTimeParts.mm}
// //                       onChange={(e) => updateEndTime("mm", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i * 5).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={endTimeParts.ap}
// //                       onChange={(e) => updateEndTime("ap", e.target.value)}
// //                     >
// //                       <option value="AM">AM</option>
// //                       <option value="PM">PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* PARTY */}
// //               <div className="booking_input_div">
// //                 <label>Party Name</label>
// //                 <select value={booking.partyName} onChange={handlePartySelect}>
// //                   <option value="">Select Party</option>
// //                   {parties.map((p, i) => (
// //                     <option key={i} value={p.HEADName}>
// //                       {p.HEADName}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Address</label>
// //                 <textarea
// //                   rows="2"
// //                   name="address"
// //                   value={booking.address}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Guest Mobile No</label>
// //                 <input
// //                   name="mobile"
// //                   value={booking.mobile}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Vehicle Type</label>
// //                 <select
// //                   name="vehicleType"
// //                   value={booking.vehicleType}
// //                   onChange={handleChange}
// //                 >
// //                   <option value="">Select</option>
// //                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
// //                     (vt, i) => (
// //                       <option key={i} value={vt}>
// //                         {vt}
// //                       </option>
// //                     ),
// //                   )}
// //                 </select>
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Guest Name</label>
// //                 <input
// //                   name="guestName"
// //                   value={booking.guestName}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Booked By</label>
// //                 <input
// //                   name="bookedBy"
// //                   value={booking.bookedBy}
// //                   onChange={handleChange}
// //                 />
// //               </div>
// //             </div>

// //             <div className="modal_footer">
// //               <button
// //                 className="booking_submit_btn"
// //                 onClick={saveBooking}
// //                 disabled={isSaving}
// //               >
// //                 {isSaving ? "Saving..." : "Save Booking"}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* EDIT MODAL (same UI, uses updateBooking) */}
// //       {showEditModal && (
// //         <div className="booking_modal">
// //           <div className="booking_modal_content">
// //             <div className="modal_header">
// //               <h5>Edit Booking</h5>
// //               <span
// //                 className="close_btn"
// //                 onClick={() => setShowEditModal(false)}
// //               >
// //                 ✕
// //               </span>
// //             </div>

// //             <div className="booking_form_scroll">
// //               {/* ================= START DATE & TIME ================= */}
// //               <div className="booking_row">
// //                 <div className="booking_input_div">
// //                   <label>Booking Start Date</label>
// //                   <input
// //                     type="date"
// //                     name="bookingDate"
// //                     value={booking.bookingDate}
// //                     onChange={handleChange}
// //                   />
// //                 </div>

// //                 <div className="booking_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={timeParts.hh}
// //                       onChange={(e) => updateTime("hh", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i + 1).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={timeParts.mm}
// //                       onChange={(e) => updateTime("mm", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i * 5).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={timeParts.ap}
// //                       onChange={(e) => updateTime("ap", e.target.value)}
// //                     >
// //                       <option value="AM">AM</option>
// //                       <option value="PM">PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* ================= END DATE & TIME ================= */}
// //               <div className="booking_row">
// //                 <div className="booking_input_div">
// //                   <label>Booking End Date</label>
// //                   <input
// //                     type="date"
// //                     name="endBookingDate"
// //                     value={booking.endBookingDate}
// //                     onChange={handleChange}
// //                   />
// //                 </div>

// //                 <div className="booking_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={endTimeParts.hh}
// //                       onChange={(e) => updateEndTime("hh", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i + 1).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={endTimeParts.mm}
// //                       onChange={(e) => updateEndTime("mm", e.target.value)}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const val = String(i * 5).padStart(2, "0");
// //                         return (
// //                           <option key={val} value={val}>
// //                             {val}
// //                           </option>
// //                         );
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={endTimeParts.ap}
// //                       onChange={(e) => updateEndTime("ap", e.target.value)}
// //                     >
// //                       <option value="AM">AM</option>
// //                       <option value="PM">PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* ================= PARTY ================= */}
// //               {/* <div className="booking_input_div">
// //                 <label>Party Name</label>
// //                 <select value={booking.partyName} onChange={handlePartySelect}>
// //                   <option value="">Select Party</option>
// //                   {parties.map((p, i) => (
// //                     <option key={i} value={p.HEADName}>
// //                       {p.HEADName}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div> */}

// //               <div className="booking_input_div">
// //                 <label>Party Name</label>
// //                 <select
// //                   name="partyName"
// //                   value={booking.partyName}
// //                   onChange={handleChange}
// //                 >
// //                   <option value="">Select Party</option>
// //                   {parties.map((p, i) => (
// //                     <option key={i} value={p.HEADName}>
// //                       {p.HEADName}
// //                     </option>
// //                   ))}
// //                 </select>
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Address</label>
// //                 <textarea
// //                   rows="2"
// //                   name="address"
// //                   value={booking.address}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Guest Mobile No</label>
// //                 <input
// //                   name="mobile"
// //                   value={booking.mobile}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Vehicle Type</label>
// //                 <select
// //                   name="vehicleType"
// //                   value={booking.vehicleType}
// //                   onChange={handleChange}
// //                 >
// //                   <option value="">Select</option>
// //                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
// //                     (vt, i) => (
// //                       <option key={i} value={vt}>
// //                         {vt}
// //                       </option>
// //                     ),
// //                   )}
// //                 </select>
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Guest Name</label>
// //                 <input
// //                   name="guestName"
// //                   value={booking.guestName}
// //                   onChange={handleChange}
// //                 />
// //               </div>

// //               <div className="booking_input_div">
// //                 <label>Booked By</label>
// //                 <input
// //                   name="bookedBy"
// //                   value={booking.bookedBy}
// //                   onChange={handleChange}
// //                 />
// //               </div>
// //             </div>

// //             <div className="modal_footer">
// //               <button
// //                 className="booking_submit_btn"
// //                 onClick={updateBooking}
// //                 disabled={isSaving}
// //               >
// //                 {isSaving ? "Saving..." : "Save Changes"}
// //               </button>
// //             </div>
// //           </div>
// //         </div>
// //       )}

// //       {/* ================= DUTY SLIP MODAL ================= */}

// //       {showDutySlipModal && (
// //         <div className="dutyslip_modal">
// //           <div className="dutyslip_modal_content">
// //             <div className="modal_header">
// //               <h5>{isDutySlipReadOnly ? "View Duty Slip" : "Generate Duty Slip"}</h5>
// //               <span
// //                 className="close_btn"
// //                 onClick={() => setShowDutySlipModal(false)}
// //               >
// //                 ✕
// //               </span>
// //             </div>

// //             <div className="dutyslip_form_scroll">
// //               <div className="dutyslip_input_div">
// //                 <label>Duty Slip Date</label>
// //                 <input
// //                   type="date"
// //                   name="slipDate"
// //                   value={dutyslip.slipDate}
// //                   onChange={handleDutySlipChange}
// //                   disabled={isDutySlipReadOnly}
// //                 />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Party Name</label>
// //                 <input value={dutyslip.partyName} readOnly />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Address</label>
// //                 <textarea value={dutyslip.address} readOnly />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Client Name</label>
// //                 <input
// //                   name="clientName"
// //                   value={dutyslip.clientName}
// //                   onChange={handleDutySlipChange}
// //                   readOnly={isDutySlipReadOnly}
// //                 />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Guest Address</label>
// //                 <textarea
// //                   rows="2"
// //                   name="clientAddress"
// //                   value={dutyslip.clientAddress}
// //                   onChange={handleDutySlipChange}
// //                   readOnly={isDutySlipReadOnly}
// //                   placeholder="Enter client address"
// //                 />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Guest Mobile</label>
// //                 <input
// //                   name="clientMobile"
// //                   value={dutyslip.clientMobile}
// //                   onChange={handleDutySlipChange}
// //                   readOnly={isDutySlipReadOnly}
// //                   placeholder="Enter client mobile"
// //                 />
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Vehicle Type</label>
// //                 <select
// //                   name="vehicleType"
// //                   value={dutyslip.vehicleType}
// //                   onChange={handleDutySlipChange}
// //                   disabled={isDutySlipReadOnly}
// //                 >
// //                   <option value="">Select</option>
// //                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
// //                     (vt, i) => (
// //                       <option key={i} value={vt}>
// //                         {vt}
// //                       </option>
// //                     ),
// //                   )}
// //                 </select>
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Car Type</label>
// //                 <select
// //                   name="acType"
// //                   value={dutyslip.acType}
// //                   onChange={handleDutySlipChange}
// //                   disabled={isDutySlipReadOnly}
// //                 >
// //                   <option value="">Select</option>
// //                   <option value="AC">AC</option>
// //                   <option value="Non AC">Non AC</option>
// //                 </select>
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Driver Name</label>
// //                 <input
// //                   name="driverName"
// //                   value={dutyslip.driverName}
// //                   onChange={handleDutySlipChange}
// //                   readOnly={isDutySlipReadOnly}
// //                 />
// //               </div>

// //               {/* Open Time */}
// //               <div className="dutyslip_row">
// //                 <div className="dutyslip_input_div">
// //                   <label>Open Date</label>
// //                   <input
// //                     type="date"
// //                     name="openDate"
// //                     value={dutyslip.openDate}
// //                     onChange={handleDutySlipChange}
// //                     disabled={isDutySlipReadOnly}
// //                   />
// //                 </div>

// //                 <div className="dutyslip_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={openTimeParts.hh}
// //                       onChange={(e) => updateOpenTime("hh", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const v = String(i + 1).padStart(2, "0");
// //                         return <option key={v}>{v}</option>;
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={openTimeParts.mm}
// //                       onChange={(e) => updateOpenTime("mm", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const v = String(i * 5).padStart(2, "0");
// //                         return <option key={v}>{v}</option>;
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={openTimeParts.ap}
// //                       onChange={(e) => updateOpenTime("ap", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       <option>AM</option>
// //                       <option>PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               {/* Close Time */}
// //               <div className="dutyslip_row">
// //                 <div className="dutyslip_input_div">
// //                   <label>Close Date</label>
// //                   <input
// //                     type="date"
// //                     name="closeDate"
// //                     value={dutyslip.closeDate}
// //                     onChange={handleDutySlipChange}
// //                     disabled={isDutySlipReadOnly}
// //                   />
// //                 </div>

// //                 <div className="dutyslip_input_div">
// //                   <label>Time</label>
// //                   <div className="time_ui">
// //                     <select
// //                       className="time_select"
// //                       value={closeTimeParts.hh}
// //                       onChange={(e) => updateCloseTime("hh", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const v = String(i + 1).padStart(2, "0");
// //                         return <option key={v}>{v}</option>;
// //                       })}
// //                     </select>

// //                     <span className="time_colon">:</span>

// //                     <select
// //                       className="time_select"
// //                       value={closeTimeParts.mm}
// //                       onChange={(e) => updateCloseTime("mm", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       {Array.from({ length: 12 }, (_, i) => {
// //                         const v = String(i * 5).padStart(2, "0");
// //                         return <option key={v}>{v}</option>;
// //                       })}
// //                     </select>

// //                     <select
// //                       className="time_select ampm_select"
// //                       value={closeTimeParts.ap}
// //                       onChange={(e) => updateCloseTime("ap", e.target.value)}
// //                       disabled={isDutySlipReadOnly}
// //                     >
// //                       <option>AM</option>
// //                       <option>PM</option>
// //                     </select>
// //                   </div>
// //                 </div>
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Total Time</label>
// //                 <input value={dutyslip.totalTime} readOnly />
// //               </div>

// //               {/* KM */}
// //               <div className="dutyslip_row">
// //                 <div className="dutyslip_input_div">
// //                   <label>KM Start</label>
// //                   <input
// //                     type="number"
// //                     name="kmStart"
// //                     value={dutyslip.kmStart}
// //                     onChange={handleDutySlipChange}
// //                     readOnly={isDutySlipReadOnly}
// //                   />
// //                 </div>

// //                 <div className="dutyslip_input_div">
// //                   <label>KM Close</label>
// //                   <input
// //                     type="number"
// //                     name="kmEnd"
// //                     value={dutyslip.kmEnd}
// //                     onChange={handleDutySlipChange}
// //                     readOnly={isDutySlipReadOnly}
// //                   />
// //                   {/* Error below KM End */}
// //                   {kmError && (
// //                     <span style={{ color: "red", fontSize: "12px" }}>
// //                       {kmError}
// //                     </span>
// //                   )}
// //                 </div>
// //               </div>

// //               <div className="dutyslip_input_div">
// //                 <label>Total KM</label>
// //                 <input value={dutyslip.totalKm} readOnly />
// //               </div>
// //             </div>

// //             <div className="modal_footer">
// //               {isDutySlipReadOnly ? (
// //                 <button
// //                   className="booking_submit_btn"
// //                   style={{ background: "#6c757d", color: "#fff" }}
// //                   onClick={() => setShowDutySlipModal(false)}
// //                 >
// //                   Close
// //                 </button>
// //               ) : (
// //                 <button
// //                   className="booking_submit_btn"
// //                   onClick={saveDutyslip}
// //                   disabled={isSaving}
// //                 >
// //                   {isSaving ? "Saving..." : "Save Duty Slip"}
// //                 </button>
// //               )}
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Booking;


// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import "./Booking.css";
// import { apiWithLog } from "../utils/apiWithLog";

// const Booking = () => {
//   const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
//   const today = new Date().toISOString().split("T")[0];

//   const [selectedDate, setSelectedDate] = useState(today);
//   const [selectedCompanyId, setSelectedCompanyId] = useState(null);
//   const lastCompanyId = useRef(null);

//   const [bookingList, setBookingList] = useState([]);
//   const [isLoadingBookings, setIsLoadingBookings] = useState(false);

//   const [parties, setParties] = useState([]);
//   const [vehicles, setVehicles] = useState([]);

//   const [showAddModal, setShowAddModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);

//   // ===== DELETE MODAL STATE =====
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [deleteId, setDeleteId] = useState(null);

//   const [editId, setEditId] = useState(null);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isEndManual, setIsEndManual] = useState(false);

//   const [showDutySlipModal, setShowDutySlipModal] = useState(false);
//   const [isDutySlipReadOnly, setIsDutySlipReadOnly] = useState(false);
//   const [selectedBooking, setSelectedBooking] = useState(null);

//   const [kmError, setKmError] = useState("");

//   // ================= TIME STATE =================
//   const [timeParts, setTimeParts] = useState({ hh: "12", mm: "00", ap: "AM" });
//   const [endTimeParts, setEndTimeParts] = useState({
//     hh: "08",
//     mm: "00",
//     ap: "AM",
//   });

//   const [booking, setBooking] = useState({
//     bookingDate: today,
//     endBookingDate: today,
//     time: "00:00:00",
//     endTime: "08:00:00",
//     partyName: "",
//     address: "",
//     mobile: "",
//     vehicleType: "",
//     guestName: "",
//     bookedBy: "",
//   });

//   // ================= COMPANY =================
//   const getCompanyId = () => {
//     try {
//       const company = JSON.parse(localStorage.getItem("selectedCompany"));
//       return company?.id || null;
//     } catch {
//       return null;
//     }
//   };

//   useEffect(() => {
//     const interval = setInterval(() => {
//       const id = getCompanyId();
//       if (id !== lastCompanyId.current) {
//         lastCompanyId.current = id;
//         setSelectedCompanyId(id);
//       }
//     }, 500);

//     return () => clearInterval(interval);
//   }, []);

//   // ================= DROPDOWNS =================
//   useEffect(() => {
//     if (!selectedCompanyId) return;

//     axios
//       .get(`${BASE_API_URL}/invoice/dropdowns/${selectedCompanyId}`)
//       .then((res) => {
//         if (res.data?.success) setParties(res.data.data || []);
//       });

//     axios
//       .get(`${BASE_API_URL}/invoice/vehicles/${selectedCompanyId}`)
//       .then((res) => {
//         if (res.data?.success) setVehicles(res.data.data || []);
//       });
//   }, [selectedCompanyId]);

//   // ================= TIME HELPERS =================
//   const buildTime24 = (parts) => {
//     let h = parseInt(parts.hh, 10);
//     if (parts.ap === "AM") {
//       if (h === 12) h = 0;
//     } else {
//       if (h !== 12) h += 12;
//     }
//     return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
//   };

//   const autoCalculateEnd = (date, time) => {
//     if (isEndManual) return;
//     if (!date || !time) return;

//     // Create LOCAL date object
//     const [year, month, day] = date.split("-");
//     const [hour, minute, second] = time.split(":");

//     const start = new Date(
//       Number(year),
//       Number(month) - 1,
//       Number(day),
//       Number(hour),
//       Number(minute),
//       Number(second || 0),
//     );

//     // Add fixed 8 hours
//     start.setHours(start.getHours() + 8);

//     // ===== LOCAL DATE (not ISO) =====
//     const endYear = start.getFullYear();
//     const endMonth = String(start.getMonth() + 1).padStart(2, "0");
//     const endDay = String(start.getDate()).padStart(2, "0");

//     const endDate = `${endYear}-${endMonth}-${endDay}`;

//     // ===== TIME =====
//     const hour24 = start.getHours();
//     const minuteLocal = start.getMinutes();

//     let hh12 = hour24 % 12;
//     if (hh12 === 0) hh12 = 12;

//     const ap = hour24 >= 12 ? "PM" : "AM";

//     const hhStr = String(hh12).padStart(2, "0");
//     const mmStr = String(minuteLocal).padStart(2, "0");

//     // Update booking (24h format)
//     setBooking((prev) => ({
//       ...prev,
//       endBookingDate: endDate,
//       endTime: `${String(hour24).padStart(2, "0")}:${mmStr}:00`,
//     }));

//     // Update dropdown (12h format)
//     setEndTimeParts({
//       hh: hhStr,
//       mm: mmStr,
//       ap,
//     });
//   };

//   // ================= TIME CHANGE =================
//   const updateTime = (key, value) => {
//     const v = key === "ap" ? value : String(value).padStart(2, "0");

//     setTimeParts((prev) => {
//       const updated = { ...prev, [key]: v };
//       const time24 = buildTime24(updated);

//       setBooking((p) => {
//         autoCalculateEnd(p.bookingDate, time24);
//         return { ...p, time: time24 };
//       });

//       return updated;
//     });
//   };

//   const updateEndTime = (key, value) => {
//     setIsEndManual(true);

//     const v = key === "ap" ? value : String(value).padStart(2, "0");

//     setEndTimeParts((prev) => {
//       const updated = { ...prev, [key]: v };
//       const time24 = buildTime24(updated);

//       setBooking((p) => ({ ...p, endTime: time24 }));
//       return updated;
//     });
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setBooking((prev) => {
//       const updated = { ...prev, [name]: value };

//       if (name === "bookingDate") {
//         autoCalculateEnd(value, updated.time);
//       }

//       if (name === "endBookingDate") {
//         setIsEndManual(true);
//       }

//       return updated;
//     });
//   };

//   // ================= PARTY AUTO FILL =================
//   const handlePartySelect = async (e) => {
//     const name = e.target.value;

//     setBooking((p) => ({
//       ...p,
//       partyName: name,
//       address: "",
//       mobile: "",
//     }));

//     if (!name || !selectedCompanyId) return;

//     const res = await axios.get(
//       `${BASE_API_URL}/invoice/dropdowns/details/${selectedCompanyId}?headName=${encodeURIComponent(
//         name,
//       )}`,
//     );

//     if (res.data?.success) {
//       const p = res.data.data || {};
//       setBooking((prev) => ({
//         ...prev,
//         address: p.ADDRESS1 || "",
//         mobile: p.MOBILE || "",
//       }));
//     }
//   };

//   const fetchBookings = async (compId, date) => {
//     console.log("fetchBookings:", compId, date);

//     if (!compId) {
//       console.log("No CompID, API not called");
//       return;
//     }

//     try {
//       setIsLoadingBookings(true);

//       const url = `${BASE_API_URL}/bookings/${compId}?date=${date}`;
//       console.log("API URL:", url);

//       const res = await axios.get(url);
//       console.log("API Response:", res.data);

//       const data = res.data?.data || res.data || [];

//       const records = data.map((row) => ({
//         id: row.BookingID,
//         bookingDate: row.BookingDate
//           ? String(row.BookingDate).split("T")[0]
//           : "",
//         time: row.time24 || "00:00:00",
//         time12: row.time12 || "",
//         endBookingDate: row.BookingEndDate
//           ? String(row.BookingEndDate).split("T")[0]
//           : "",
//         endTime: row.endTime24 || "00:00:00",
//         endTime12: row.endTime12 || "",
//         partyName: row.PartyName || "",
//         address: row.ClientAddress || "",
//         mobile: row.Mobile || "",
//         vehicleType: row.CarType || "",
//         guestName: row.ClientName || "",
//         bookedBy: row.Detail || "",
//         companyId: row.CompID,
//         dutyslipId: row.DutyslipID || null,
//       }));

//       setBookingList(records);
//     } catch (err) {
//       console.log("Fetch Booking Error:", err);
//       toast.error("Failed to fetch bookings");
//       setBookingList([]);
//     } finally {
//       setIsLoadingBookings(false);
//     }
//   };

//   useEffect(() => {
//     if (selectedCompanyId) {
//       fetchBookings(selectedCompanyId, selectedDate);
//     }
//   }, [selectedCompanyId, selectedDate]);

//   // ================= SAVE =================
//   const saveBooking = async () => {
//     if (!validateBookingForm()) return;

//     try {
//       setIsSaving(true);

//       const payload = {
//         bookingDate: booking.bookingDate,
//         time: buildTime24(timeParts),

//         bookingEndDate: booking.endBookingDate,
//         bookingEndTime: booking.endTime,

//         partyName: booking.partyName,
//         clientAddress: booking.address,
//         mobile: booking.mobile,
//         carType: booking.vehicleType,
//         clientName: booking.guestName,
//         detail: booking.bookedBy,

//         compId: selectedCompanyId,
//       };
//       const res = await apiWithLog({
//         method: "POST",
//         url: `${BASE_API_URL}/bookings/create`,
//         data: payload,
//         module: "Booking",
//         action: "A",
//       });

//       console.log("✅ Booking API Response:", res);
//       console.log("✅ Booking Data:", res.data);

//       if (res.data?.success) {
//         toast.success("Booking Saved");

//         setShowAddModal(false);
//         fetchBookings(selectedCompanyId, selectedDate);
//       } else {
//         toast.error("Save failed");
//       }
//     } catch (err) {
//       toast.error("Server error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const updateBooking = async () => {
//     if (!validateBookingForm()) return;

//     if (!editId) {
//       toast.error("Booking ID missing");
//       return;
//     }

//     try {
//       setIsSaving(true);

//       const payload = {
//         bookingDate: booking.bookingDate,
//         time: buildTime24(timeParts),
//         bookingEndDate: booking.endBookingDate,
//         bookingEndTime: booking.endTime,
//         partyName: booking.partyName,
//         clientAddress: booking.address,
//         mobile: booking.mobile,
//         carType: booking.vehicleType,
//         clientName: booking.guestName,
//         detail: booking.bookedBy,
//         compId: selectedCompanyId,
//       };

//       // const res = await axios.put(
//       //   `${BASE_API_URL}/bookings/update/${editId}`,
//       //   payload,
//       // );

//       const res = await apiWithLog({
//         method: "PUT",
//         url: `${BASE_API_URL}/bookings/update/${editId}`,
//         data: payload,
//         module: "Booking",
//         action: "E",
//       });

//       if (res.data?.success) {
//         toast.success("Booking updated");
//         setShowEditModal(false);

//         // reload same date data
//         fetchBookings(selectedCompanyId, selectedDate);
//       } else {
//         toast.error("Update failed");
//       }
//     } catch (err) {
//       toast.error("Server error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // Open delete popup
//   const openDeleteModal = (id) => {
//     setDeleteId(id);
//     setShowDeleteModal(true);
//   };

//   // Confirm delete
//   const confirmDeleteBooking = async () => {
//     try {
//       // await axios.delete(`${BASE_API_URL}/bookings/delete/${deleteId}`);

//       const res = await apiWithLog({
//         method: "DELETE",
//         url: `${BASE_API_URL}/bookings/delete/${deleteId}`,
//         module: "Booking",
//         action: "D",
//       });

//       toast.success("Booking deleted");

//       setShowDeleteModal(false);
//       setDeleteId(null);

//       fetchBookings(selectedCompanyId, selectedDate);
//     } catch (err) {
//       toast.error("Delete failed");
//     }
//   };

//   const openNewBooking = () => {
//     setEditId(null);
//     setIsEndManual(false);

//     // Reset time dropdown
//     setTimeParts({
//       hh: "12",
//       mm: "00",
//       ap: "AM",
//     });

//     // Reset end time dropdown
//     setEndTimeParts({
//       hh: "08",
//       mm: "00",
//       ap: "AM",
//     });

//     // Reset form
//     const startTime = "00:00:00";

//     setBooking({
//       bookingDate: today,
//       endBookingDate: today,
//       time: startTime,
//       endTime: "08:00:00",
//       partyName: "",
//       address: "",
//       mobile: "",
//       vehicleType: "",
//       guestName: "",
//       bookedBy: "",
//     });

//     // Auto calculate end time again
//     autoCalculateEnd(today, startTime);

//     setShowAddModal(true);
//   };

//   const openEditBooking = (b) => {
//     setEditId(b.id);

//     // Allow auto end recalculation
//     setIsEndManual(false);

//     const bookingDate = b.bookingDate || today;
//     const endBookingDate = b.endBookingDate || bookingDate;

//     const startTime = b.time || "00:00:00";
//     const endTime = b.endTime || "08:00:00";

//     // Start time dropdown
//     const [sh, sm] = startTime.split(":");
//     let sh12 = parseInt(sh, 10);
//     let sap = "AM";

//     if (sh12 === 0) sh12 = 12;
//     else if (sh12 === 12) sap = "PM";
//     else if (sh12 > 12) {
//       sh12 -= 12;
//       sap = "PM";
//     }

//     setTimeParts({
//       hh: String(sh12).padStart(2, "0"),
//       mm: sm,
//       ap: sap,
//     });

//     // End time dropdown
//     const [eh, em] = endTime.split(":");
//     let eh12 = parseInt(eh, 10);
//     let eap = "AM";

//     if (eh12 === 0) eh12 = 12;
//     else if (eh12 === 12) eap = "PM";
//     else if (eh12 > 12) {
//       eh12 -= 12;
//       eap = "PM";
//     }

//     setEndTimeParts({
//       hh: String(eh12).padStart(2, "0"),
//       mm: em,
//       ap: eap,
//     });

//     setBooking({
//       bookingDate,
//       endBookingDate,
//       time: startTime,
//       endTime,
//       partyName: b.partyName || b.PartyName || "",
//       address: b.address || "",
//       mobile: b.mobile || "",
//       vehicleType: b.vehicleType || "",
//       guestName: b.guestName || "",
//       bookedBy: b.bookedBy || "",
//     });

//     setShowEditModal(true);
//   };

//   const filteredBookings = bookingList;

//   const [dutyslip, setDutyslip] = useState({
//     slipDate: today,
//     partyName: "",
//     address: "",
//     clientName: "",
//     clientAddress: "",
//     clientMobile: "",
//     vehicleType: "",
//     acType: "",
//     driverName: "",
//     kmStart: "",
//     kmEnd: "",
//     totalKm: "",
//     openDate: today,
//     closeDate: today,
//     totalTime: "",
//     bookingId: null,
//   });

//   const [errors, setErrors] = useState({});

//   const [openTimeParts, setOpenTimeParts] = useState({
//     hh: "09",
//     mm: "00",
//     ap: "AM",
//   });

//   const [closeTimeParts, setCloseTimeParts] = useState({
//     hh: "05",
//     mm: "00",
//     ap: "PM",
//   });

//   const buildTime24FromParts = (parts) => {
//     let h = parseInt(parts.hh, 10);

//     if (parts.ap === "AM") {
//       if (h === 12) h = 0;
//     } else {
//       if (h !== 12) h += 12;
//     }

//     return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
//   };

//   const buildDateTime = (date, parts) => {
//     const time = buildTime24FromParts(parts);
//     return `${date} ${time}`;
//   };

//   const getCurrentISTDateTime = () => {
//     const now = new Date();

//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, "0");
//     const day = String(now.getDate()).padStart(2, "0");

//     const hours = String(now.getHours()).padStart(2, "0");
//     const minutes = String(now.getMinutes()).padStart(2, "0");
//     const seconds = String(now.getSeconds()).padStart(2, "0");

//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   };

//   const parseTimeParts = (timeStr) => {
//     if (!timeStr) return { hh: "12", mm: "00", ap: "AM" };
//     const [hStr, mStr] = timeStr.split(":");
//     let h = parseInt(hStr, 10) || 0;
//     const mm = String(parseInt(mStr, 10) || 0).padStart(2, "0");
//     let ap = "AM";

//     if (h === 0) {
//       h = 12;
//     } else if (h === 12) {
//       ap = "PM";
//     } else if (h > 12) {
//       h -= 12;
//       ap = "PM";
//     }

//     const hh = String(h).padStart(2, "0");
//     return { hh, mm, ap };
//   };

//   const parseDateTime = (dateStr, timeStr) => {
//     if (!dateStr || !timeStr) return new Date(NaN);
//     let year, month, day;
//     const cleanDate = dateStr.trim().split(" ")[0].split("T")[0];
//     if (cleanDate.includes("-")) {
//       const parts = cleanDate.split("-");
//       if (parts[0].length === 4) {
//         [year, month, day] = parts;
//       } else {
//         [day, month, year] = parts;
//       }
//     } else if (cleanDate.includes("/")) {
//       const parts = cleanDate.split("/");
//       if (parts[0].length === 4) {
//         [year, month, day] = parts;
//       } else {
//         [day, month, year] = parts;
//       }
//     } else {
//       return new Date(cleanDate);
//     }

//     const [h, m, s] = timeStr.split(":");
//     return new Date(
//       Number(year),
//       Number(month) - 1,
//       Number(day),
//       Number(h || 0),
//       Number(m || 0),
//       Number(s || 0)
//     );
//   };

//   const calculateTotalTime = (openDate, openParts, closeDate, closeParts) => {
//     if (!openDate || !closeDate) return;

//     const openTime = buildTime24FromParts(openParts);
//     const closeTime = buildTime24FromParts(closeParts);

//     const open = parseDateTime(openDate, openTime);
//     const close = parseDateTime(closeDate, closeTime);

//     const diffMs = close - open;

//     if (diffMs <= 0 || isNaN(diffMs)) {
//       setDutyslip((prev) => ({ ...prev, totalTime: "" }));
//       return;
//     }

//     const hours = Math.floor(diffMs / (1000 * 60 * 60));
//     const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

//     setDutyslip((prev) => ({
//       ...prev,
//       totalTime: `${hours}h ${minutes}m`,
//     }));
//   };

//   // ===== Open Time
//   const updateOpenTime = (key, value) => {
//     const v = key === "ap" ? value : String(value).padStart(2, "0");

//     setOpenTimeParts((prev) => {
//       const updated = { ...prev, [key]: v };

//       calculateTotalTime(
//         dutyslip.openDate,
//         updated,
//         dutyslip.closeDate,
//         closeTimeParts,
//       );

//       return updated;
//     });
//   };

//   // ===== Close Time
//   const updateCloseTime = (key, value) => {
//     const v = key === "ap" ? value : String(value).padStart(2, "0");

//     setCloseTimeParts((prev) => {
//       const updated = { ...prev, [key]: v };

//       calculateTotalTime(
//         dutyslip.openDate,
//         openTimeParts,
//         dutyslip.closeDate,
//         updated,
//       );

//       return updated;
//     });
//   };

//   const handleDutySlipChange = (e) => {
//     const { name, value } = e.target;

//     setDutyslip((prev) => {
//       const updated = { ...prev, [name]: value };

//       // ===== Recalculate totalTime on date change
//       if (name === "openDate" || name === "closeDate") {
//         calculateTotalTime(
//           name === "openDate" ? value : updated.openDate,
//           openTimeParts,
//           name === "closeDate" ? value : updated.closeDate,
//           closeTimeParts
//         );
//       }

//       // ===== Auto Total KM (Added)
//       if (name === "kmStart" || name === "kmEnd") {
//         const start = parseFloat(updated.kmStart) || 0;
//         const end = parseFloat(updated.kmEnd) || 0;

//         if (updated.kmEnd === "" || updated.kmStart === "") {
//           updated.totalKm = "";
//           setErrors((prev) => ({ ...prev, km: "" }));
//         }
//         // If End < Start → show error
//         else if (end < start) {
//           updated.totalKm = "";
//           setErrors((prev) => ({
//             ...prev,
//             km: "KM Close cannot be less than KM Start",
//           }));
//         }
//         // Valid case → calculate total
//         else {
//           updated.totalKm = end - start;
//           setErrors((prev) => ({ ...prev, km: "" }));
//         }
//       }

//       return updated;
//     });
//   };
//   const validateForm = () => {
//     if (
//       !dutyslip.clientName?.trim() ||
//       !dutyslip.clientMobile?.trim() ||
//       !dutyslip.vehicleType ||
//       !dutyslip.acType ||
//       !dutyslip.driverName?.trim() ||
//       !dutyslip.kmStart ||
//       !dutyslip.kmEnd ||
//       !dutyslip.totalTime
//     ) {
//       toast.error("All fields are required");
//       return false;
//     }

//     if (!/^\d{10}$/.test(dutyslip.clientMobile)) {
//       toast.error("Enter valid 10 digit mobile");
//       return false;
//     }

//     if (Number(dutyslip.kmEnd) < Number(dutyslip.kmStart)) {
//       toast.error("KM Close cannot be less than KM Start");
//       return false;
//     }

//     return true;
//   };

//   const validateBookingForm = () => {
//     if (
//       !booking.partyName ||
//       !booking.address ||
//       !booking.mobile ||
//       !booking.vehicleType ||
//       !booking.guestName ||
//       !booking.bookedBy ||
//       !booking.bookingDate ||
//       !booking.endBookingDate
//     ) {
//       toast.error("All fields are required");
//       return false;
//     }

//     if (!/^\d{10}$/.test(booking.mobile)) {
//       toast.error("Enter valid 10 digit mobile");
//       return false;
//     }

//     return true;
//   };
//   const openDutySlipModal = async (booking) => {
//     // Save selected booking
//     setSelectedBooking(booking);

//     // Clear errors
//     setErrors({});

//     if (booking.dutyslipId) {
//       // If duty slip already exists, fetch it and display as read-only
//       setIsDutySlipReadOnly(true);
//       try {
//         const res = await axios.get(`${BASE_API_URL}/dutyslip/dutyslip?id=${booking.dutyslipId}`);
//         if (res.data?.success && res.data.data?.length > 0) {
//           const ds = res.data.data[0];
          
//           const slipDate = ds.DutyslipDate ? String(ds.DutyslipDate).split("T")[0] : today;
//           const openDate = ds.DutyslipDate ? String(ds.DutyslipDate).split("T")[0] : today;
//           const closeDate = ds.DutyslipEndDate ? String(ds.DutyslipEndDate).split("T")[0] : today;

//           const splitTime = (time) => {
//             if (!time) return { hh: "12", mm: "00", ap: "AM" };
//             let [h, m] = time.split(":");
//             h = parseInt(h, 10);
//             let ap = "AM";
//             if (h >= 12) {
//               ap = "PM";
//               if (h > 12) h -= 12;
//             }
//             if (h === 0) h = 12;
//             return {
//               hh: String(h).padStart(2, "0"),
//               mm: m || "00",
//               ap,
//             };
//           };

//           const openParts = splitTime(ds.time24);
//           const closeParts = splitTime(ds.endTime24);

//           setOpenTimeParts(openParts);
//           setCloseTimeParts(closeParts);

//           setDutyslip({
//             slipDate,
//             openDate,
//             closeDate,
//             totalTime: ds.TotalTime ? `${ds.TotalTime}h` : "",
//             partyName: ds.PartyName || booking.partyName || "",
//             address: ds.PartyAddress || booking.address || "",
//             clientName: ds.ClientName || booking.guestName || "",
//             clientAddress: ds.ClientAddress || booking.address || "",
//             clientMobile: ds.Mobile || booking.mobile || "",
//             vehicleType: ds.VehicleType || booking.vehicleType || "",
//             acType: ds.CarType || "AC",
//             driverName: ds.DriverName || "",
//             kmStart: ds.KMStart ?? "",
//             kmEnd: ds.KMClose ?? "",
//             totalKm: ds.TotalKM ?? "",
//             bookingId: booking.id || booking.BookingID || null,
//           });

//           setShowDutySlipModal(true);
//         } else {
//           toast.error("Failed to load duty slip details");
//         }
//       } catch (err) {
//         console.error("Error loading duty slip:", err);
//         toast.error("Error loading duty slip details");
//       }
//     } else {
//       // If no duty slip, prepare for generating one (editable mode)
//       setIsDutySlipReadOnly(false);

//       const openDate = booking.bookingDate || today;
//       const closeDate = booking.endBookingDate || booking.bookingDate || today;

//       // Parse time parts from booking time/endTime
//       const openParts = parseTimeParts(booking.time);
//       const closeParts = parseTimeParts(booking.endTime);

//       setOpenTimeParts(openParts);
//       setCloseTimeParts(closeParts);

//       // Calculate initial total time
//       const openTime24 = buildTime24FromParts(openParts);
//       const closeTime24 = buildTime24FromParts(closeParts);

//       const open = parseDateTime(openDate, openTime24);
//       const close = parseDateTime(closeDate, closeTime24);
//       const diffMs = close - open;
//       let initialTotalTime = "";
//       if (diffMs > 0 && !isNaN(diffMs)) {
//         const hours = Math.floor(diffMs / (1000 * 60 * 60));
//         const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
//         initialTotalTime = `${hours}h ${minutes}m`;
//       }

//       // Fill DutySlip form with booking data
//       setDutyslip({
//         slipDate: today,

//         partyName: booking.partyName || "",
//         address: booking.address || "",
//         clientName: booking.guestName || booking.clientName || "",
//         clientAddress: booking.address || "",
//         clientMobile: booking.mobile || "",

//         vehicleType: booking.vehicleType || "",
//         acType: "",

//         driverName: "",
//         kmStart: "",
//         kmEnd: "",
//         totalKm: "",

//         openDate,
//         closeDate,

//         totalTime: initialTotalTime,

//         // ✅ IMPORTANT – BookingId set here
//         bookingId: booking.id || booking.BookingID || null,
//       });

//       // Open modal
//       setShowDutySlipModal(true);
//     }
//   };

//   const saveDutyslip = async () => {
//     if (!validateForm()) return;

//     try {
//       setIsSaving(true);

//       const openTime = `${dutyslip.openDate} ${buildTime24FromParts(openTimeParts)}`;
//       const closeTime = `${dutyslip.closeDate} ${buildTime24FromParts(closeTimeParts)}`;

//       // ===== Current IST SlipDate (Added)
//       const slipDate = getCurrentISTDateTime();

//       // Convert totalTime string "8h 30m" to float 8.5
//       let totalTimeFloat = 0;
//       if (dutyslip.totalTime) {
//         const match = dutyslip.totalTime.match(/(\d+)h\s*(\d*)m?/);
//         if (match) {
//           const h = parseInt(match[1], 10) || 0;
//           const m = parseInt(match[2], 10) || 0;
//           totalTimeFloat = h + (m / 60);
//         }
//       }

//       const payload = {
//         slipDate,
//         partyName: dutyslip.partyName,
//         clientName: dutyslip.clientName,
//         clientAddress: dutyslip.clientAddress || dutyslip.address || "",
//         clientMobile: dutyslip.clientMobile,
//         vehicleType: dutyslip.vehicleType,
//         carType: dutyslip.acType,
//         driverName: dutyslip.driverName,
//         kmStart: Number(dutyslip.kmStart),
//         kmEnd: Number(dutyslip.kmEnd),
//         totalKm: Number(dutyslip.totalKm),
//         openTime,
//         closeTime,
//         totalTime: totalTimeFloat,
//         bookingId: dutyslip.bookingId || null,
//         compId: selectedCompanyId,
//       };

//       const res = await apiWithLog({
//         method: "POST",
//         url: `${BASE_API_URL}/dutyslip/create`,
//         data: payload,
//         module: "Generate DutySlip",
//         action: "A",
//       });

//       if (res.data?.success) {
//         toast.success("Duty Slip Saved");
//         const newDutyslipId = res.data.id;
        
//         // Update local bookingList state
//         setBookingList((prevList) =>
//           prevList.map((b) =>
//             b.id === dutyslip.bookingId ? { ...b, dutyslipId: newDutyslipId } : b
//           )
//         );

//         // Re-sync from the server so the persisted DutyslipID is confirmed
//         fetchBookings(selectedCompanyId, selectedDate);

//         // Switch to read-only view
//         setIsDutySlipReadOnly(true);
//       } else {
//         toast.error(res.data.message);
//       }
//     } catch (err) {
//       toast.error("Server error");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return (
//     <div className="booking_container">
//       <ToastContainer autoClose={2000} />

//       {/* TOP BAR */}
//       <div className="booking_top">
//         <div className="booking_date_inline">
//           <span className="booking_date_label">Booking Date</span>
//           <input
//             type="date"
//             className="booking_date_input"
//             value={selectedDate}
//             onChange={(e) => setSelectedDate(e.target.value)}
//           />
//         </div>

//         <button className="new_booking_btn" onClick={openNewBooking}>
//           New Booking
//         </button>
//       </div>

//       {/* BOOKING LIST */}
//       <div className="booking_list_section">
//         <h6>
//           Booking List{" "}
//           {isLoadingBookings && (
//             <span style={{ fontSize: "12px", color: "#666" }}>
//               (Loading...)
//             </span>
//           )}
//         </h6>

//         <table className="booking_table">
//           <thead>
//             <tr>
//               <th>Party</th>
//               <th>Guest Name</th>
//               <th>Guest Mobile No</th>
//               <th>Vehicle</th>
//               <th>Booked By</th>
//               <th>Start Time</th>
//               <th>End Date</th>
//               <th>End Time</th>
//               <th>Action</th>
//             </tr>
//           </thead>

//           <tbody>
//             {filteredBookings.length === 0 ? (
//               <tr>
//                 <td colSpan="9" className="no_data">
//                   No bookings found
//                 </td>
//               </tr>
//             ) : (
//               filteredBookings.map((b) => (
//                 <tr key={b.id}>
//                   <td>{b.partyName}</td>
//                   <td>{b.guestName}</td>
//                   <td>{b.mobile}</td>
//                   <td>{b.vehicleType}</td>
//                   <td>{b.bookedBy}</td>
//                   <td>{b.time12 || "-"}</td>
//                   <td>{b.endBookingDate || "-"}</td>
//                   <td>{b.endTime12 || "-"}</td>

//                   <td className="action_cell">
//                     <button
//                       className="action_btn edit_btn"
//                       onClick={() => openEditBooking(b)}
//                     >
//                       Edit
//                     </button>
//                     <button
//                       className="action_btn delete_btn"
//                       onClick={() => openDeleteModal(b.id)}
//                     >
//                       Delete
//                     </button>

//                     <button
//                       className="action_btn"
//                       style={{ background: "#198754", color: "#fff" }}
//                       onClick={() => openDutySlipModal(b)}
//                     >
//                       Duty Slip
//                     </button>
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* ===== DELETE CONFIRM MODAL ===== */}
//       {showDeleteModal && (
//         <div className="delete_modal_overlay">
//           <div className="delete_modal_box">
//             <span
//               className="delete_close"
//               onClick={() => setShowDeleteModal(false)}
//             >
//               ✕
//             </span>

//             <div className="delete_icon">
//               <span className="delete_svg_icon">🗑️</span>
//             </div>

//             <div className="delete_title">Delete Booking?</div>

//             <div className="delete_text">
//               Are you sure you want to delete this booking?
//             </div>

//             <div className="delete_actions">
//               <button
//                 className="delete_cancel_btn"
//                 onClick={() => setShowDeleteModal(false)}
//               >
//                 Cancel
//               </button>

//               <button
//                 className="delete_confirm_btn"
//                 onClick={confirmDeleteBooking}
//               >
//                 Confirm
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ================= ADD MODAL ================= */}
//       {showAddModal && (
//         <div className="booking_modal">
//           <div className="booking_modal_content">
//             <div className="modal_header">
//               <h5>New Booking</h5>
//               <span
//                 className="close_btn"
//                 onClick={() => setShowAddModal(false)}
//               >
//                 ✕
//               </span>
//             </div>

//             <div className="booking_form_scroll">
//               {/* START */}
//               <div className="booking_row">
//                 <div className="booking_input_div">
//                   <label>Booking Start Date</label>
//                   <input
//                     type="date"
//                     name="bookingDate"
//                     value={booking.bookingDate}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="booking_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={timeParts.hh}
//                       onChange={(e) => updateTime("hh", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i + 1).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={timeParts.mm}
//                       onChange={(e) => updateTime("mm", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i * 5).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={timeParts.ap}
//                       onChange={(e) => updateTime("ap", e.target.value)}
//                     >
//                       <option value="AM">AM</option>
//                       <option value="PM">PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* END */}
//               <div className="booking_row">
//                 <div className="booking_input_div">
//                   <label>Booking End Date</label>
//                   <input
//                     type="date"
//                     name="endBookingDate"
//                     value={booking.endBookingDate}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="booking_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={endTimeParts.hh}
//                       onChange={(e) => updateEndTime("hh", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i + 1).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={endTimeParts.mm}
//                       onChange={(e) => updateEndTime("mm", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i * 5).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={endTimeParts.ap}
//                       onChange={(e) => updateEndTime("ap", e.target.value)}
//                     >
//                       <option value="AM">AM</option>
//                       <option value="PM">PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* PARTY */}
//               <div className="booking_input_div">
//                 <label>Party Name</label>
//                 <select value={booking.partyName} onChange={handlePartySelect}>
//                   <option value="">Select Party</option>
//                   {parties.map((p, i) => (
//                     <option key={i} value={p.HEADName}>
//                       {p.HEADName}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="booking_input_div">
//                 <label>Address</label>
//                 <textarea
//                   rows="2"
//                   name="address"
//                   value={booking.address}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Guest Mobile No</label>
//                 <input
//                   name="mobile"
//                   value={booking.mobile}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Vehicle Type</label>
//                 <select
//                   name="vehicleType"
//                   value={booking.vehicleType}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select</option>
//                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
//                     (vt, i) => (
//                       <option key={i} value={vt}>
//                         {vt}
//                       </option>
//                     ),
//                   )}
//                 </select>
//               </div>

//               <div className="booking_input_div">
//                 <label>Guest Name</label>
//                 <input
//                   name="guestName"
//                   value={booking.guestName}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Booked By</label>
//                 <input
//                   name="bookedBy"
//                   value={booking.bookedBy}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="modal_footer">
//               <button
//                 className="booking_submit_btn"
//                 onClick={saveBooking}
//                 disabled={isSaving}
//               >
//                 {isSaving ? "Saving..." : "Save Booking"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* EDIT MODAL (same UI, uses updateBooking) */}
//       {showEditModal && (
//         <div className="booking_modal">
//           <div className="booking_modal_content">
//             <div className="modal_header">
//               <h5>Edit Booking</h5>
//               <span
//                 className="close_btn"
//                 onClick={() => setShowEditModal(false)}
//               >
//                 ✕
//               </span>
//             </div>

//             <div className="booking_form_scroll">
//               {/* ================= START DATE & TIME ================= */}
//               <div className="booking_row">
//                 <div className="booking_input_div">
//                   <label>Booking Start Date</label>
//                   <input
//                     type="date"
//                     name="bookingDate"
//                     value={booking.bookingDate}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="booking_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={timeParts.hh}
//                       onChange={(e) => updateTime("hh", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i + 1).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={timeParts.mm}
//                       onChange={(e) => updateTime("mm", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i * 5).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={timeParts.ap}
//                       onChange={(e) => updateTime("ap", e.target.value)}
//                     >
//                       <option value="AM">AM</option>
//                       <option value="PM">PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* ================= END DATE & TIME ================= */}
//               <div className="booking_row">
//                 <div className="booking_input_div">
//                   <label>Booking End Date</label>
//                   <input
//                     type="date"
//                     name="endBookingDate"
//                     value={booking.endBookingDate}
//                     onChange={handleChange}
//                   />
//                 </div>

//                 <div className="booking_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={endTimeParts.hh}
//                       onChange={(e) => updateEndTime("hh", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i + 1).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={endTimeParts.mm}
//                       onChange={(e) => updateEndTime("mm", e.target.value)}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const val = String(i * 5).padStart(2, "0");
//                         return (
//                           <option key={val} value={val}>
//                             {val}
//                           </option>
//                         );
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={endTimeParts.ap}
//                       onChange={(e) => updateEndTime("ap", e.target.value)}
//                     >
//                       <option value="AM">AM</option>
//                       <option value="PM">PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* ================= PARTY ================= */}
//               <div className="booking_input_div">
//                 <label>Party Name</label>
//                 <select
//                   name="partyName"
//                   value={booking.partyName}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select Party</option>
//                   {parties.map((p, i) => (
//                     <option key={i} value={p.HEADName}>
//                       {p.HEADName}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="booking_input_div">
//                 <label>Address</label>
//                 <textarea
//                   rows="2"
//                   name="address"
//                   value={booking.address}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Guest Mobile No</label>
//                 <input
//                   name="mobile"
//                   value={booking.mobile}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Vehicle Type</label>
//                 <select
//                   name="vehicleType"
//                   value={booking.vehicleType}
//                   onChange={handleChange}
//                 >
//                   <option value="">Select</option>
//                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
//                     (vt, i) => (
//                       <option key={i} value={vt}>
//                         {vt}
//                       </option>
//                     ),
//                   )}
//                 </select>
//               </div>

//               <div className="booking_input_div">
//                 <label>Guest Name</label>
//                 <input
//                   name="guestName"
//                   value={booking.guestName}
//                   onChange={handleChange}
//                 />
//               </div>

//               <div className="booking_input_div">
//                 <label>Booked By</label>
//                 <input
//                   name="bookedBy"
//                   value={booking.bookedBy}
//                   onChange={handleChange}
//                 />
//               </div>
//             </div>

//             <div className="modal_footer">
//               <button
//                 className="booking_submit_btn"
//                 onClick={updateBooking}
//                 disabled={isSaving}
//               >
//                 {isSaving ? "Saving..." : "Save Changes"}
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ================= DUTY SLIP MODAL ================= */}

//       {showDutySlipModal && (
//         <div className="dutyslip_modal">
//           <div className="dutyslip_modal_content">
//             <div className="modal_header">
//               <h5>{isDutySlipReadOnly ? "View Duty Slip" : "Generate Duty Slip"}</h5>
//               <span
//                 className="close_btn"
//                 onClick={() => setShowDutySlipModal(false)}
//               >
//                 ✕
//               </span>
//             </div>

//             <div className="dutyslip_form_scroll">
//               <div className="dutyslip_input_div">
//                 <label>Duty Slip Date</label>
//                 <input
//                   type="date"
//                   name="slipDate"
//                   value={dutyslip.slipDate}
//                   onChange={handleDutySlipChange}
//                   disabled={isDutySlipReadOnly}
//                 />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Party Name</label>
//                 <input value={dutyslip.partyName} readOnly />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Address</label>
//                 <textarea value={dutyslip.address} readOnly />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Client Name</label>
//                 <input
//                   name="clientName"
//                   value={dutyslip.clientName}
//                   onChange={handleDutySlipChange}
//                   readOnly={isDutySlipReadOnly}
//                 />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Guest Address</label>
//                 <textarea
//                   rows="2"
//                   name="clientAddress"
//                   value={dutyslip.clientAddress}
//                   onChange={handleDutySlipChange}
//                   readOnly={isDutySlipReadOnly}
//                   placeholder="Enter client address"
//                 />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Guest Mobile</label>
//                 <input
//                   name="clientMobile"
//                   value={dutyslip.clientMobile}
//                   onChange={handleDutySlipChange}
//                   readOnly={isDutySlipReadOnly}
//                   placeholder="Enter client mobile"
//                 />
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Vehicle Type</label>
//                 <select
//                   name="vehicleType"
//                   value={dutyslip.vehicleType}
//                   onChange={handleDutySlipChange}
//                   disabled={isDutySlipReadOnly}
//                 >
//                   <option value="">Select</option>
//                   {[...new Set(vehicles.map((v) => v.VehicleTypeName))].map(
//                     (vt, i) => (
//                       <option key={i} value={vt}>
//                         {vt}
//                       </option>
//                     ),
//                   )}
//                 </select>
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Car Type</label>
//                 <select
//                   name="acType"
//                   value={dutyslip.acType}
//                   onChange={handleDutySlipChange}
//                   disabled={isDutySlipReadOnly}
//                 >
//                   <option value="">Select</option>
//                   <option value="AC">AC</option>
//                   <option value="Non AC">Non AC</option>
//                 </select>
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Driver Name</label>
//                 <input
//                   name="driverName"
//                   value={dutyslip.driverName}
//                   onChange={handleDutySlipChange}
//                   readOnly={isDutySlipReadOnly}
//                 />
//               </div>

//               {/* Open Time */}
//               <div className="dutyslip_row">
//                 <div className="dutyslip_input_div">
//                   <label>Open Date</label>
//                   <input
//                     type="date"
//                     name="openDate"
//                     value={dutyslip.openDate}
//                     onChange={handleDutySlipChange}
//                     disabled={isDutySlipReadOnly}
//                   />
//                 </div>

//                 <div className="dutyslip_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={openTimeParts.hh}
//                       onChange={(e) => updateOpenTime("hh", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const v = String(i + 1).padStart(2, "0");
//                         return <option key={v}>{v}</option>;
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={openTimeParts.mm}
//                       onChange={(e) => updateOpenTime("mm", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const v = String(i * 5).padStart(2, "0");
//                         return <option key={v}>{v}</option>;
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={openTimeParts.ap}
//                       onChange={(e) => updateOpenTime("ap", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       <option>AM</option>
//                       <option>PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* Close Time */}
//               <div className="dutyslip_row">
//                 <div className="dutyslip_input_div">
//                   <label>Close Date</label>
//                   <input
//                     type="date"
//                     name="closeDate"
//                     value={dutyslip.closeDate}
//                     onChange={handleDutySlipChange}
//                     disabled={isDutySlipReadOnly}
//                   />
//                 </div>

//                 <div className="dutyslip_input_div">
//                   <label>Time</label>
//                   <div className="time_ui">
//                     <select
//                       className="time_select"
//                       value={closeTimeParts.hh}
//                       onChange={(e) => updateCloseTime("hh", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const v = String(i + 1).padStart(2, "0");
//                         return <option key={v}>{v}</option>;
//                       })}
//                     </select>

//                     <span className="time_colon">:</span>

//                     <select
//                       className="time_select"
//                       value={closeTimeParts.mm}
//                       onChange={(e) => updateCloseTime("mm", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       {Array.from({ length: 12 }, (_, i) => {
//                         const v = String(i * 5).padStart(2, "0");
//                         return <option key={v}>{v}</option>;
//                       })}
//                     </select>

//                     <select
//                       className="time_select ampm_select"
//                       value={closeTimeParts.ap}
//                       onChange={(e) => updateCloseTime("ap", e.target.value)}
//                       disabled={isDutySlipReadOnly}
//                     >
//                       <option>AM</option>
//                       <option>PM</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Total Time</label>
//                 <input value={dutyslip.totalTime} readOnly />
//               </div>

//               {/* KM */}
//               <div className="dutyslip_row">
//                 <div className="dutyslip_input_div">
//                   <label>KM Start</label>
//                   <input
//                     type="number"
//                     name="kmStart"
//                     value={dutyslip.kmStart}
//                     onChange={handleDutySlipChange}
//                     readOnly={isDutySlipReadOnly}
//                   />
//                 </div>

//                 <div className="dutyslip_input_div">
//                   <label>KM Close</label>
//                   <input
//                     type="number"
//                     name="kmEnd"
//                     value={dutyslip.kmEnd}
//                     onChange={handleDutySlipChange}
//                     readOnly={isDutySlipReadOnly}
//                   />
//                   {/* Error below KM End */}
//                   {kmError && (
//                     <span style={{ color: "red", fontSize: "12px" }}>
//                       {kmError}
//                     </span>
//                   )}
//                 </div>
//               </div>

//               <div className="dutyslip_input_div">
//                 <label>Total KM</label>
//                 <input value={dutyslip.totalKm} readOnly />
//               </div>
//             </div>

//             <div className="modal_footer">
//               {isDutySlipReadOnly ? (
//                 <button
//                   className="booking_submit_btn"
//                   style={{ background: "#6c757d", color: "#fff" }}
//                   onClick={() => setShowDutySlipModal(false)}
//                 >
//                   Close
//                 </button>
//               ) : (
//                 <button
//                   className="booking_submit_btn"
//                   onClick={saveDutyslip}
//                   disabled={isSaving}
//                 >
//                   {isSaving ? "Saving..." : "Save Duty Slip"}
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Booking;


import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import { showToast } from "../utils/customToast";
import DeleteConfirmModal from "../Component/DeleteModal/DeleteConfirmModal";
import "./Booking.css";
import { apiWithLog } from "../utils/apiWithLog";
import { TableRowsSkeleton } from "../Component/Skeleton";
import SearchableSelect from "../Component/SearchableSelect/SearchableSelect";
import { cleanPartyOrAddress } from "../utils/stringUtils";

const TIME_HOURS = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));
const TIME_MINUTES = Array.from({ length: 12 }, (_, i) => String(i * 5).padStart(2, "0"));

const Booking = () => {
  const BASE_API_URL = process.env.REACT_APP_BASE_API_URL;
  const today = new Date().toISOString().split("T")[0];

  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const lastCompanyId = useRef(null);

  const [bookingList, setBookingList] = useState([]);
  const [isLoadingBookings, setIsLoadingBookings] = useState(false);

  const [parties, setParties] = useState([]);
  const [vehicles, setVehicles] = useState([]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  // ===== DELETE MODAL STATE =====
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteItemName, setDeleteItemName] = useState("");
  const [isDeleting, setIsDeleting] = useState(false);

  const [editId, setEditId] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [isEndManual, setIsEndManual] = useState(false);

  const [showDutySlipModal, setShowDutySlipModal] = useState(false);
  const [isDutySlipReadOnly, setIsDutySlipReadOnly] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);

  const [kmError, setKmError] = useState("");

  // NEW: Fare package dropdown state
  const [packages, setPackages] = useState([]);
  const [selectedPackageId, setSelectedPackageId] = useState("");

  const [showAddVehicleModal, setShowAddVehicleModal] = useState(false);
  const [vehicleTypesList, setVehicleTypesList] = useState([]);
  const [ownersList, setOwnersList] = useState([]);
  const [isAddingVehicle, setIsAddingVehicle] = useState(false);
  const [targetFormForNewVehicle, setTargetFormForNewVehicle] = useState("booking");
  const [newVehicleForm, setNewVehicleForm] = useState({
    vtypeName: "",
    vehicleNumber: "",
    ownerID: "",
    modelYear: new Date().getFullYear(),
  });

  const [showAddVehicleTypeOnlyModal, setShowAddVehicleTypeOnlyModal] = useState(false);
  const [newVehicleTypeNameInput, setNewVehicleTypeNameInput] = useState("");
  const [isSavingVehicleTypeOnly, setIsSavingVehicleTypeOnly] = useState(false);

  const openAddVehicleTypeOnlyModal = () => {
    setNewVehicleTypeNameInput("");
    setShowAddVehicleTypeOnlyModal(true);
  };

  const handleAddVehicleTypeOnlySubmit = async () => {
    if (!newVehicleTypeNameInput.trim()) {
      showToast.warn("Vehicle type name is required");
      return;
    }
    setIsSavingVehicleTypeOnly(true);
    try {
      const res = await axios.post(`${BASE_API_URL}/vehicles/vehicletypes/create`, {
        VTYPE: newVehicleTypeNameInput.trim(),
      });
      if (res.data?.success) {
        const savedName = res.data.vehicleType.VehicleTypeName;
        showToast.save(`Vehicle Type "${savedName}" added successfully!`);
        await fetchVehicleDropdowns(selectedCompanyId);
        setBooking((prev) => ({ ...prev, vehicleType: savedName }));
        setShowAddVehicleTypeOnlyModal(false);
      } else {
        showToast.error(res.data?.message || "Failed to add vehicle type");
      }
    } catch (err) {
      showToast.error(err?.response?.data?.message || "Server error");
    } finally {
      setIsSavingVehicleTypeOnly(false);
    }
  };

  // ================= TIME STATE =================
  const [timeParts, setTimeParts] = useState({ hh: "12", mm: "00", ap: "AM" });
  const [endTimeParts, setEndTimeParts] = useState({
    hh: "08",
    mm: "00",
    ap: "AM",
  });

  const [booking, setBooking] = useState({
    bookingDate: today,
    endBookingDate: today,
    time: "00:00:00",
    endTime: "08:00:00",
    partyName: "",
    address: "",
    mobile: "",
    vehicleType: "",
    vehicleNo: "",
    guestName: "",
    bookedBy: "",
  });

  // ================= COMPANY =================
  const getCompanyId = () => {
    try {
      const company = JSON.parse(localStorage.getItem("selectedCompany"));
      return company?.id || null;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const id = getCompanyId();
      if (id !== lastCompanyId.current) {
        lastCompanyId.current = id;
        setSelectedCompanyId(id);
      }
    }, 500);

    return () => clearInterval(interval);
  }, []);

  // ================= DROPDOWNS =================
  useEffect(() => {
    if (!selectedCompanyId) return;

    axios
      .get(`${BASE_API_URL}/invoice/dropdowns/${selectedCompanyId}`)
      .then((res) => {
        if (res.data?.success) {
          const list = (res.data.data || []).map((p) => ({
            ...p,
            HEADName: cleanPartyOrAddress(p.HEADName),
            ADDRESS1: cleanPartyOrAddress(p.ADDRESS1),
          }));
          setParties(list);
        }
      });

    axios
      .get(`${BASE_API_URL}/invoice/vehicles/${selectedCompanyId}`)
      .then((res) => {
        if (res.data?.success) setVehicles(res.data.data || []);
      });

    fetchVehicleDropdowns(selectedCompanyId);
  }, [selectedCompanyId]);

  // ── Refresh just the vehicles list (called after adding a new vehicle) ──
  const refreshVehicles = async (compId) => {
    try {
      const res = await axios.get(`${BASE_API_URL}/invoice/vehicles/${compId}`);
      if (res.data?.success) setVehicles(res.data.data || []);
    } catch (e) {
      console.warn("refreshVehicles error:", e);
    }
  };

  // ── Fetch vehicle types + owners ──
  const fetchVehicleDropdowns = async (compId) => {
    try {
      if (compId) {
        const res = await axios.get(`${BASE_API_URL}/vehicles/dropdowns/${compId}`);
        if (res.data?.success) {
          if (res.data.vehicleTypes?.length) setVehicleTypesList(res.data.vehicleTypes);
          setOwnersList(res.data.owners || []);
        }
      }
      const vtRes = await axios.get(`${BASE_API_URL}/vehicles/vehicletypes`);
      if (vtRes.data?.success && vtRes.data.vehicleTypes?.length) {
        setVehicleTypesList(vtRes.data.vehicleTypes);
      }
    } catch (e) {
      console.warn("fetchVehicleDropdowns error:", e);
    }
  };

  useEffect(() => {
    fetchVehicleDropdowns(selectedCompanyId);
  }, []);

  // Compute all unique vehicle types from master table + vehicles
  const allVehicleTypes = useMemo(() => {
    const map = new Map();
    vehicleTypesList.forEach((vt) => {
      if (vt.VehicleTypeName) {
        map.set(vt.VehicleTypeName.toLowerCase(), vt.VehicleTypeName);
      }
    });
    vehicles.forEach((v) => {
      if (v.VehicleTypeName && !map.has(v.VehicleTypeName.toLowerCase())) {
        map.set(v.VehicleTypeName.toLowerCase(), v.VehicleTypeName);
      }
    });
    return Array.from(map.values()).sort();
  }, [vehicleTypesList, vehicles]);

  const openAddVehicleModal = () => {
    setNewVehicleForm({
      vtypeName: "",
      vehicleNumber: "",
      ownerID: "",
      modelYear: new Date().getFullYear(),
    });
    setTargetFormForNewVehicle("booking");
    if (selectedCompanyId) fetchVehicleDropdowns(selectedCompanyId);
    setShowAddVehicleModal(true);
  };

  const openAddVehicleModalForDutySlip = (currentVehicleType) => {
    setNewVehicleForm({
      vtypeName: currentVehicleType || "",
      vehicleNumber: "",
      self: 0,
      ownerID: "",
      modelYear: new Date().getFullYear(),
    });
    setTargetFormForNewVehicle("dutyslip");
    if (selectedCompanyId) fetchVehicleDropdowns(selectedCompanyId);
    setShowAddVehicleModal(true);
  };

  const handleAddVehicleSubmit = async () => {
    const { vtypeName, vehicleNumber, ownerID, modelYear, self } = newVehicleForm;

    if (!vtypeName.trim()) { showToast.warn("Vehicle Type name is required"); return; }
    if (!vehicleNumber.trim()) { showToast.warn("Vehicle Number is required"); return; }
    if (!ownerID) { showToast.warn("Owner is required"); return; }
    if (!selectedCompanyId) { showToast.warn("Select a company first"); return; }

    setIsAddingVehicle(true);
    try {
      // ── Step 1: Add/get vehicle type ──────────────────────────
      let savedTypeName = vtypeName.trim();
      if (newVehicleForm.isCustomType) {
        try {
          const vtRes = await axios.post(`${BASE_API_URL}/vehicles/vehicletypes/create`, {
            VTYPE: vtypeName.trim(),
          });

          if (vtRes.data?.success && vtRes.data.vehicleType?.VehicleTypeName) {
            savedTypeName = vtRes.data.vehicleType.VehicleTypeName;
          }
        } catch (vtErr) {
          console.warn("Vehicle type creation notice:", vtErr);
        }
      }

      // ── Step 2: Add vehicle ───────────────────────────────────
      const vRes = await axios.post(`${BASE_API_URL}/vehicles/create`, {
        vehicleNumber: vehicleNumber.trim(),
        vehicleType: savedTypeName,
        ownerID: ownerID,
        modelYear: modelYear ? parseInt(modelYear) : null,
        self: (self === 1 || self === "1") ? 1 : 0,
        CompID: selectedCompanyId,
      });

      if (!vRes.data?.success) {
        showToast.error(vRes.data?.error || "Failed to create vehicle");
        return;
      }

      showToast.save(`Vehicle "${vehicleNumber.trim()}" added successfully!`);

      // ── Step 3: Refresh dropdowns & auto-select ───────
      await refreshVehicles(selectedCompanyId);
      await fetchVehicleDropdowns(selectedCompanyId);

      if (targetFormForNewVehicle === "dutyslip") {
        setDutyslip((prev) => ({
          ...prev,
          vehicleType: savedTypeName,
          vehicleNo: vehicleNumber.trim(),
        }));
      } else {
        setBooking((prev) => ({ ...prev, vehicleType: savedTypeName }));
      }

      setShowAddVehicleModal(false);
    } catch (err) {
      showToast.error(err?.response?.data?.error || err?.response?.data?.message || "Server error");
    } finally {
      setIsAddingVehicle(false);
    }
  };



  // ================= TIME HELPERS =================
  const buildTime24 = (parts) => {
    let h = parseInt(parts.hh, 10);
    if (parts.ap === "AM") {
      if (h === 12) h = 0;
    } else {
      if (h !== 12) h += 12;
    }
    return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
  };

  const autoCalculateEnd = (date, time) => {
    if (isEndManual) return;
    if (!date || !time) return;

    // Create LOCAL date object
    const [year, month, day] = date.split("-");
    const [hour, minute, second] = time.split(":");

    const start = new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second || 0),
    );

    // Add fixed 8 hours
    start.setHours(start.getHours() + 8);

    // ===== LOCAL DATE (not ISO) =====
    const endYear = start.getFullYear();
    const endMonth = String(start.getMonth() + 1).padStart(2, "0");
    const endDay = String(start.getDate()).padStart(2, "0");

    const endDate = `${endYear}-${endMonth}-${endDay}`;

    // ===== TIME =====
    const hour24 = start.getHours();
    const minuteLocal = start.getMinutes();

    let hh12 = hour24 % 12;
    if (hh12 === 0) hh12 = 12;

    const ap = hour24 >= 12 ? "PM" : "AM";

    const hhStr = String(hh12).padStart(2, "0");
    const mmStr = String(minuteLocal).padStart(2, "0");

    // Update booking (24h format)
    setBooking((prev) => ({
      ...prev,
      endBookingDate: endDate,
      endTime: `${String(hour24).padStart(2, "0")}:${mmStr}:00`,
    }));

    // Update dropdown (12h format)
    setEndTimeParts({
      hh: hhStr,
      mm: mmStr,
      ap,
    });
  };

  // ================= TIME CHANGE =================
  const updateTime = (key, value) => {
    const v = key === "ap" ? value : String(value).padStart(2, "0");

    setTimeParts((prev) => {
      const updated = { ...prev, [key]: v };
      const time24 = buildTime24(updated);

      setBooking((p) => {
        autoCalculateEnd(p.bookingDate, time24);
        return { ...p, time: time24 };
      });

      return updated;
    });
  };

  const updateEndTime = (key, value) => {
    setIsEndManual(true);

    const v = key === "ap" ? value : String(value).padStart(2, "0");

    setEndTimeParts((prev) => {
      const updated = { ...prev, [key]: v };
      const time24 = buildTime24(updated);

      setBooking((p) => ({ ...p, endTime: time24 }));
      return updated;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setBooking((prev) => {
      const updated = { ...prev, [name]: value };

      if (name === "bookingDate") {
        autoCalculateEnd(value, updated.time);
      }

      if (name === "endBookingDate") {
        setIsEndManual(true);
      }

      return updated;
    });
  };

  // ================= PARTY AUTO FILL =================
  const handlePartySelect = async (e) => {
    const rawVal = e?.target?.value !== undefined ? e.target.value : e;
    const name = cleanPartyOrAddress(rawVal);

    setBooking((p) => ({
      ...p,
      partyName: name,
      address: "",
      mobile: "",
    }));

    if (!name || !selectedCompanyId) return;

    const res = await axios.get(
      `${BASE_API_URL}/invoice/dropdowns/details/${selectedCompanyId}?headName=${encodeURIComponent(
        name,
      )}`,
    );

    if (res.data?.success) {
      const p = res.data.data || {};
      setBooking((prev) => ({
        ...prev,
        address: cleanPartyOrAddress(p.ADDRESS1 || p.Address || ""),
        mobile: (p.MOBILE || "").trim(),
      }));
    }
  };

  const fetchBookings = async (compId, date) => {
    console.log("fetchBookings:", compId, date);

    if (!compId) {
      console.log("No CompID, API not called");
      return;
    }

    try {
      setIsLoadingBookings(true);

      const url = `${BASE_API_URL}/bookings/${compId}?date=${date}`;
      console.log("API URL:", url);

      const res = await axios.get(url);
      console.log("API Response:", res.data);

      const data = res.data?.data || res.data || [];

      const records = data.map((row) => ({
        id: row.BookingID,
        bookingDate: row.BookingDate
          ? String(row.BookingDate).split("T")[0]
          : "",
        time: row.time24 || "00:00:00",
        time12: row.time12 || "",
        endBookingDate: row.BookingEndDate
          ? String(row.BookingEndDate).split("T")[0]
          : "",
        endTime: row.endTime24 || "00:00:00",
        endTime12: row.endTime12 || "",
        partyName: row.PartyName || "",
        address: row.ClientAddress || "",
        mobile: row.Mobile || "",
        vehicleType: row.CarType || "",
        vehicleNo: row.VehicleNo || "",
        guestName: row.ClientName || "",
        bookedBy: row.Detail || "",
        companyId: row.CompID,
        dutyslipId: row.DutyslipID || null,
      }));

      setBookingList(records);
    } catch (err) {
      console.log("Fetch Booking Error:", err);
      showToast.error("Failed to fetch bookings");
      setBookingList([]);
    } finally {
      setIsLoadingBookings(false);
    }
  };

  useEffect(() => {
    if (selectedCompanyId) {
      fetchBookings(selectedCompanyId, selectedDate);
    }
  }, [selectedCompanyId, selectedDate]);

  // ================= SAVE =================
  const saveBooking = async () => {
    if (isSaving) return;
    if (!validateBookingForm()) return;

    try {
      setIsSaving(true);

      const payload = {
        bookingDate: booking.bookingDate,
        time: buildTime24(timeParts),

        bookingEndDate: booking.endBookingDate,
        bookingEndTime: booking.endTime,

        partyName: booking.partyName,
        clientAddress: booking.address,
        mobile: booking.mobile,
        carType: booking.vehicleType,
        vehicleNo: booking.vehicleNo,
        clientName: booking.guestName,
        detail: booking.bookedBy,

        compId: selectedCompanyId,
      };
      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/bookings/create`,
        data: payload,
        module: "Booking",
        action: "A",
      });

      console.log("✅ Booking API Response:", res);
      console.log("✅ Booking Data:", res.data);

      if (res.data?.success) {
        showToast.save("Booking saved successfully!");

        setShowAddModal(false);
        fetchBookings(selectedCompanyId, selectedDate);
      } else {
        showToast.error(res.data?.message || "Save failed");
      }
    } catch (err) {
      showToast.error("Server error");
    } finally {
      setIsSaving(false);
    }
  };

  const updateBooking = async () => {
    if (isSaving) return;
    if (!validateBookingForm()) return;

    if (!editId) {
      showToast.error("Booking ID missing");
      return;
    }

    try {
      setIsSaving(true);

      const payload = {
        bookingDate: booking.bookingDate,
        time: buildTime24(timeParts),
        bookingEndDate: booking.endBookingDate,
        bookingEndTime: booking.endTime,
        partyName: booking.partyName,
        clientAddress: booking.address,
        mobile: booking.mobile,
        carType: booking.vehicleType,
        vehicleNo: booking.vehicleNo,
        clientName: booking.guestName,
        detail: booking.bookedBy,
        compId: selectedCompanyId,
      };

      const res = await apiWithLog({
        method: "PUT",
        url: `${BASE_API_URL}/bookings/update/${editId}`,
        data: payload,
        module: "Booking",
        action: "E",
      });

      if (res.data?.success) {
        showToast.save("Booking updated successfully!");
        setShowEditModal(false);

        // reload same date data
        fetchBookings(selectedCompanyId, selectedDate);
      } else {
        showToast.error(res.data?.message || "Update failed");
      }
    } catch (err) {
      showToast.error("Server error");
    } finally {
      setIsSaving(false);
    }
  };

  // Open delete popup
  const openDeleteModal = (bookingItem) => {
    if (!bookingItem) return;
    const id = typeof bookingItem === "object" ? bookingItem.id : bookingItem;
    const name = typeof bookingItem === "object"
      ? (bookingItem.guestName ? `${bookingItem.partyName || "Booking"} - ${bookingItem.guestName}` : `Booking #${bookingItem.id}`)
      : `Booking #${id}`;
    setDeleteId(id);
    setDeleteItemName(name);
    setShowDeleteModal(true);
  };

  // Confirm delete
  const confirmDeleteBooking = async () => {
    if (isDeleting) return;
    if (!deleteId) return;
    try {
      setIsDeleting(true);
      const res = await apiWithLog({
        method: "DELETE",
        url: `${BASE_API_URL}/bookings/delete/${deleteId}`,
        module: "Booking",
        action: "D",
      });

      showToast.delete("Booking deleted successfully!");

      setShowDeleteModal(false);
      setDeleteId(null);
      setDeleteItemName("");

      fetchBookings(selectedCompanyId, selectedDate);
    } catch (err) {
      showToast.error("Delete failed");
    } finally {
      setIsDeleting(false);
    }
  };

  const openNewBooking = () => {
    setEditId(null);
    setIsEndManual(false);

    // Reset time dropdown
    setTimeParts({
      hh: "12",
      mm: "00",
      ap: "AM",
    });

    // Reset end time dropdown
    setEndTimeParts({
      hh: "08",
      mm: "00",
      ap: "AM",
    });

    // Reset form
    const startTime = "00:00:00";

    setBooking({
      bookingDate: today,
      endBookingDate: today,
      time: startTime,
      endTime: "08:00:00",
      partyName: "",
      address: "",
      mobile: "",
      vehicleType: "",
      guestName: "",
      bookedBy: "",
    });

    // Auto calculate end time again
    autoCalculateEnd(today, startTime);

    setShowAddModal(true);
  };

  const openEditBooking = (b) => {
    setEditId(b.id);

    // Allow auto end recalculation
    setIsEndManual(false);

    const bookingDate = b.bookingDate || today;
    const endBookingDate = b.endBookingDate || bookingDate;

    const startTime = b.time || "00:00:00";
    const endTime = b.endTime || "08:00:00";

    // Start time dropdown
    const [sh, sm] = startTime.split(":");
    let sh12 = parseInt(sh, 10);
    let sap = "AM";

    if (sh12 === 0) sh12 = 12;
    else if (sh12 === 12) sap = "PM";
    else if (sh12 > 12) {
      sh12 -= 12;
      sap = "PM";
    }

    setTimeParts({
      hh: String(sh12).padStart(2, "0"),
      mm: sm,
      ap: sap,
    });

    // End time dropdown
    const [eh, em] = endTime.split(":");
    let eh12 = parseInt(eh, 10);
    let eap = "AM";

    if (eh12 === 0) eh12 = 12;
    else if (eh12 === 12) eap = "PM";
    else if (eh12 > 12) {
      eh12 -= 12;
      eap = "PM";
    }

    setEndTimeParts({
      hh: String(eh12).padStart(2, "0"),
      mm: em,
      ap: eap,
    });

    setBooking({
      bookingDate,
      endBookingDate,
      time: startTime,
      endTime,
      partyName: b.partyName || b.PartyName || "",
      address: b.address || "",
      mobile: b.mobile || "",
      vehicleType: b.vehicleType || "",
      vehicleNo: b.vehicleNo || "",
      guestName: b.guestName || "",
      bookedBy: b.bookedBy || "",
    });

    setShowEditModal(true);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const filteredBookings = bookingList;

  useEffect(() => {
    setCurrentPage(1);
  }, [bookingList, selectedDate]);

  const totalPages = Math.ceil(filteredBookings.length / itemsPerPage) || 1;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedBookings = filteredBookings.slice(startIndex, startIndex + itemsPerPage);

  const [dutyslip, setDutyslip] = useState({
    slipDate: today,
    partyName: "",
    address: "",
    clientName: "",
    clientAddress: "",
    clientMobile: "",
    vehicleType: "",
    vehicleNo: "",
    acType: "",
    driverName: "",
    kmStart: "",
    kmEnd: "",
    totalKm: "",
    openDate: today,
    closeDate: today,
    totalTime: "",
    bookingId: null,
  });

  const [dateWiseRows, setDateWiseRows] = useState([]);
  const [errors, setErrors] = useState({});

  // ================= NEW: FETCH FARE PACKAGES =================
  useEffect(() => {
    if (!dutyslip.vehicleType || !selectedCompanyId) {
      setPackages([]);
      return;
    }

    axios
      .get(
        `${BASE_API_URL}/dutyslip/fares/list/${encodeURIComponent(dutyslip.vehicleType)}?CompID=${selectedCompanyId}`
      )
      .then((res) => {
        if (res.data?.success) {
          const list = res.data.data || [];
          setPackages(list);
          // Only auto-select if vehicle type has linked packages
          const firstAssigned = list.find((p) => p.IsAssigned === 1);
          if (firstAssigned) {
            setSelectedPackageId((prev) => prev || String(firstAssigned.ID));
            setDateWiseRows((prevRows) => {
              const normalized = normalizeDateWiseRows(prevRows);
              return normalized.map((row) => {
                if (!row.fareId) {
                  return {
                    ...row,
                    fareId: String(firstAssigned.ID),
                    packageName: firstAssigned.PackageName || "",
                  };
                }
                return row;
              });
            });
          }
        } else {
          setPackages([]);
        }
      })
      .catch(() => setPackages([]));
  }, [dutyslip.vehicleType, selectedCompanyId]);

  const hasInputValue = (value) =>
    value !== null && value !== undefined && String(value).trim() !== "";

  const firstFilledValue = (...values) =>
    values.find((value) => hasInputValue(value)) ?? "";

  const parseTotalTimeToMinutes = (str) => {
    if (!str || typeof str !== "string") return 0;
    let hours = 0, minutes = 0;
    const hMatch = str.match(/(\d+)\s*h/i);
    const mMatch = str.match(/(\d+)\s*m/i);
    if (hMatch) hours = parseInt(hMatch[1], 10);
    if (mMatch) minutes = parseInt(mMatch[1], 10);
    if (!hMatch && !mMatch) {
      const num = parseInt(str, 10);
      if (!isNaN(num)) hours = num;
    }
    return hours * 60 + minutes;
  };

  const formatMinutesToTotalTime = (minutes) => {
    if (minutes === null || minutes === undefined || isNaN(minutes) || minutes < 0) return "";
    const h = Math.floor(minutes / 60);
    const m = minutes % 60;
    if (m > 0) return `${h}h ${m}m`;
    return `${h}h`;
  };

  const timePartsToMinutes = (parts) => {
    let h = parseInt(parts.hh, 10) % 12;
    if (parts.ap === "PM") h += 12;
    return h * 60 + parseInt(parts.mm, 10);
  };

  const overnightAwareDiffMinutes = (openMin, closeMin) =>
    closeMin >= openMin ? closeMin - openMin : closeMin + 1440 - openMin;

  const toInputDate = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value.split("T")[0].split(" ")[0];
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "";
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDisplayDate = (value) => {
    const clean = toInputDate(value);
    if (!clean) return "";
    const [year, month, day] = clean.split("-");
    return `${day}-${month}-${year}`;
  };

  const createBlankDateWiseRow = (date) => ({
    date,
    kmStartGarage: "",
    kmStartUser: "",
    kmClose: "",
    kmCloseGarage: "",
    totalKm: "",
    openingTime: "",
    closingTime: "",
    totalTime: "",
    timeError: "",
    tripDetails: "",
    fareId: selectedPackageId || "",
    packageName: packages.find((p) => String(p.ID) === String(selectedPackageId))?.PackageName || "",
  });

  const getDateRange = (startDate, endDate) => {
    const start = toInputDate(startDate);
    const end = toInputDate(endDate || startDate);
    if (!start) return [];
    const startObj = new Date(`${start}T00:00:00`);
    const endObj = new Date(`${end || start}T00:00:00`);
    if (Number.isNaN(startObj.getTime()) || Number.isNaN(endObj.getTime())) {
      return [start];
    }
    const dates = [];
    const cursor = new Date(startObj);
    const last = endObj >= startObj ? endObj : startObj;
    while (cursor <= last) {
      const year = cursor.getFullYear();
      const month = String(cursor.getMonth() + 1).padStart(2, "0");
      const day = String(cursor.getDate()).padStart(2, "0");
      dates.push(`${year}-${month}-${day}`);
      cursor.setDate(cursor.getDate() + 1);
    }
    return dates;
  };

  const normalizeDateWiseRows = (rows = []) =>
    rows.map((row) => ({
      ...createBlankDateWiseRow(
        toInputDate(row.date || row.tripDate || row.TripDate),
      ),
      kmStartGarage: row.kmStartGarage ?? row.KMStartGarage ?? "",
      kmStartUser: row.kmStartUser ?? row.KMStartUser ?? "",
      kmClose: row.kmClose ?? row.KMClose ?? "",
      kmCloseGarage: row.kmCloseGarage ?? row.KMCloseGarage ?? "",
      totalKm: row.totalKm ?? row.TotalKM ?? "",
      openingTime: row.openingTime || row.OpeningTime || "",
      closingTime: row.closingTime || row.ClosingTime || "",
      totalTime: row.totalTime || row.TotalTime || "",
      timeError: row.timeError || "",
      tripDetails: row.tripDetails ?? row.TripDetails ?? "",
      fareId: row.fareId ?? row.FareId ?? "",
      packageName: row.packageName ?? row.PackageName ?? "",
    }));

  const buildDateWisePayload = (rows = dateWiseRows) =>
    normalizeDateWiseRows(rows).map((row) => ({
      date: row.date,
      kmStartGarage: Number(row.kmStartGarage) || 0,
      kmStartUser: Number(row.kmStartUser) || 0,
      kmClose: Number(row.kmClose) || 0,
      kmCloseGarage: Number(row.kmCloseGarage) || 0,
      totalKm: Number(row.totalKm) || 0,
      openingTime: row.openingTime || "",
      closingTime: row.closingTime || "",
      totalTime: row.totalTime || "",
      tripDetails: row.tripDetails || "",
      fareId: row.fareId || null,
    }));

  const updateBoundaryDateWiseTime = (boundary, timeText) => {
    setDateWiseRows((prevRows) => {
      const rows = normalizeDateWiseRows(prevRows);
      if (!rows.length) return rows;
      const index = boundary === "open" ? 0 : rows.length - 1;
      const field = boundary === "open" ? "openingTime" : "closingTime";
      rows[index] = { ...rows[index], [field]: timeText };
      const merged = mergeDateWiseRows(
        dutyslip.openDate,
        dutyslip.closeDate,
        rows,
        {
          [field]: timeText,
        }
      );
      return merged;
    });
  };

  const mergeDateWiseRows = (startDate, endDate, rows = [], summary = {}) => {
    const rangeDates = getDateRange(startDate, endDate);
    const existingRows = normalizeDateWiseRows(rows);
    const existingMap = {};
    existingRows.forEach((row) => {
      if (row.date && (rangeDates.length === 0 || rangeDates.includes(row.date))) {
        existingMap[row.date] = row;
      }
    });

    if (rangeDates.length) {
      rangeDates.forEach((date) => {
        if (!existingMap[date]) {
          existingMap[date] = createBlankDateWiseRow(date);
        }
      });
    }

    let merged = Object.values(existingMap);
    if (rangeDates.length) {
      merged = merged.filter((r) => rangeDates.includes(r.date));
    }
    merged.sort((a, b) => a.date.localeCompare(b.date));

    const openTimeStr = summary.openingTime || (openTimeParts ? formatTimePartsToString(openTimeParts) : "");
    const closeTimeStr = summary.closingTime || (closeTimeParts ? formatTimePartsToString(closeTimeParts) : "");

    if (merged.length) {
      merged[0] = {
        ...merged[0],
        kmStartGarage: firstFilledValue(
          merged[0].kmStartGarage,
          summary.kmStart,
        ),
        kmStartUser: firstFilledValue(merged[0].kmStartUser, summary.kmStart),
        openingTime: summary.openingTime || openTimeStr || merged[0].openingTime || "",
      };
      const lastIndex = merged.length - 1;
      merged[lastIndex] = {
        ...merged[lastIndex],
        kmClose: firstFilledValue(merged[lastIndex].kmClose, summary.kmEnd),
        kmCloseGarage: firstFilledValue(
          merged[lastIndex].kmCloseGarage,
          summary.kmEnd,
        ),
        closingTime: summary.closingTime || closeTimeStr || merged[lastIndex].closingTime || "",
      };
    }

    merged.forEach((r) => {
      const kmStartVal = firstFilledValue(r.kmStartGarage, r.kmStartUser);
      const kmCloseVal = firstFilledValue(r.kmCloseGarage, r.kmClose);
      if (hasInputValue(kmStartVal) && hasInputValue(kmCloseVal)) {
        const kmStart = Number(kmStartVal);
        const kmClose = Number(kmCloseVal);
        if (!Number.isNaN(kmStart) && !Number.isNaN(kmClose) && kmClose >= kmStart) {
          r.totalKm = kmClose - kmStart;
        } else {
          r.totalKm = "";
        }
      } else {
        r.totalKm = "";
      }
      if (r.openingTime && r.closingTime) {
        const openMin = timePartsToMinutes(
          parseTimeParts(r.openingTime),
        );
        const closeMin = timePartsToMinutes(
          parseTimeParts(r.closingTime),
        );
        const diff = overnightAwareDiffMinutes(openMin, closeMin);
        r.totalTime = formatMinutesToTotalTime(diff);
        r.timeError = "";
      } else {
        r.totalTime = "";
      }
    });

    const grandSummary = getRowsSummary(merged);
    setDutyslip((prev) => ({
      ...prev,
      kmStart: grandSummary.kmStart,
      kmEnd: grandSummary.kmEnd,
      totalKm: grandSummary.totalKm,
      totalTime: grandSummary.totalTime,
    }));

    return merged;
  };

  const getRowsSummary = (rows) => {
    const cleanRows = normalizeDateWiseRows(rows).filter((row) => row.date);
    const first = cleanRows[0] || {};
    const lastWithClose =
      [...cleanRows]
        .reverse()
        .find(
          (row) =>
            hasInputValue(row.kmCloseGarage) || hasInputValue(row.kmClose),
        ) || {};
    const totalFromRows = cleanRows.reduce(
      (sum, row) => sum + (Number(row.totalKm) || 0),
      0,
    );
    const kmStart = firstFilledValue(first.kmStartUser, first.kmStartGarage);
    const kmEnd = firstFilledValue(
      lastWithClose.kmClose,
      lastWithClose.kmCloseGarage,
    );
    const calculatedTotal =
      hasInputValue(kmStart) &&
      hasInputValue(kmEnd) &&
      Number(kmEnd) >= Number(kmStart)
        ? Number(kmEnd) - Number(kmStart)
        : "";
    const hasRowTotals = cleanRows.some((row) => hasInputValue(row.totalKm));
    const finalTotalKm = hasRowTotals
      ? totalFromRows
      : hasInputValue(calculatedTotal)
        ? calculatedTotal
        : "";

    let totalMinutes = 0;
    cleanRows.forEach((row) => {
      if (row.totalTime) {
        totalMinutes += parseTotalTimeToMinutes(row.totalTime);
      }
    });
    const totalTime = formatMinutesToTotalTime(totalMinutes);

    return {
      kmStart,
      kmEnd,
      totalKm: finalTotalKm,
      totalTime,
      totalTimeMinutes: totalMinutes,
    };
  };

  const handleDateWiseChange = (index, field, value) => {
    setDateWiseRows((prevRows) => {
      const updatedRows = normalizeDateWiseRows(prevRows).map(
        (row, rowIndex) => {
          if (rowIndex !== index) return row;
          const updated = { ...row, [field]: value };
          if (field === "kmStartUser") {
            updated.kmStartGarage = value;
          }
          if (field === "kmClose") {
            updated.kmCloseGarage = value;
          }
          if (field !== "totalKm") {
            const kmStartVal = firstFilledValue(
              updated.kmStartUser,
              updated.kmStartGarage,
            );
            const kmCloseVal = firstFilledValue(
              updated.kmClose,
              updated.kmCloseGarage,
            );
            if (hasInputValue(kmStartVal) && hasInputValue(kmCloseVal)) {
              const kmStart = Number(kmStartVal);
              const kmClose = Number(kmCloseVal);
              if (
                !Number.isNaN(kmStart) &&
                !Number.isNaN(kmClose) &&
                kmClose >= kmStart
              ) {
                updated.totalKm = kmClose - kmStart;
              } else {
                updated.totalKm = "";
              }
            } else {
              updated.totalKm = "";
            }
          }
          if (field !== "totalTime") {
            if (updated.openingTime && updated.closingTime) {
              const openMin = timePartsToMinutes(
                parseTimeParts(updated.openingTime),
              );
              const closeMin = timePartsToMinutes(
                parseTimeParts(updated.closingTime),
              );
              const diff = overnightAwareDiffMinutes(openMin, closeMin);
              updated.totalTime = formatMinutesToTotalTime(diff);
              updated.timeError = "";
            } else {
              updated.totalTime = "";
            }
          }
          return updated;
        },
      );

      if (field === "openingTime" && index === 0 && value) {
        const parts = parseTimeParts(value);
        if (parts) setOpenTimeParts(parts);
      }
      if (field === "closingTime" && index === updatedRows.length - 1 && value) {
        const parts = parseTimeParts(value);
        if (parts) setCloseTimeParts(parts);
      }

      const summary = getRowsSummary(updatedRows);
      setDutyslip((prev) => ({
        ...prev,
        kmStart: summary.kmStart,
        kmEnd: summary.kmEnd,
        totalKm: summary.totalKm,
        totalTime: summary.totalTime,
      }));

      return updatedRows;
    });
  };

  const addDateWiseRow = () => {
    const lastDateStr =
      dateWiseRows.length > 0
        ? dateWiseRows[dateWiseRows.length - 1].date
        : dutyslip.openDate || today;
    let nextDateStr = lastDateStr;
    if (lastDateStr) {
      const d = new Date(lastDateStr);
      d.setDate(d.getDate() + 1);
      nextDateStr = d.toISOString().split("T")[0];
    }
    setDateWiseRows((prev) => [...prev, createBlankDateWiseRow(nextDateStr)]);
  };

  const handleTopPackageChange = (packageId) => {
    setSelectedPackageId(packageId);
    const pkgObj = packages.find((p) => String(p.ID) === String(packageId));
    const pkgName = pkgObj?.PackageName || "";
    setDateWiseRows((prevRows) =>
      normalizeDateWiseRows(prevRows).map((row) => ({
        ...row,
        fareId: packageId || "",
        packageName: pkgName,
      }))
    );
  };

  const [openTimeParts, setOpenTimeParts] = useState({
    hh: "09",
    mm: "00",
    ap: "AM",
  });

  const [closeTimeParts, setCloseTimeParts] = useState({
    hh: "05",
    mm: "00",
    ap: "PM",
  });

  const buildTime24FromParts = (parts) => {
    let h = parseInt(parts.hh, 10);

    if (parts.ap === "AM") {
      if (h === 12) h = 0;
    } else {
      if (h !== 12) h += 12;
    }

    return `${String(h).padStart(2, "0")}:${parts.mm}:00`;
  };

  const buildDateTime = (date, parts) => {
    const time = buildTime24FromParts(parts);
    return `${date} ${time}`;
  };

  const getCurrentISTDateTime = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  };

  const parseTimeParts = (timeStr) => {
    if (!timeStr) return { hh: "12", mm: "00", ap: "AM" };
    const s = String(timeStr).trim();
    if (!s || s === "-") return { hh: "12", mm: "00", ap: "AM" };

    let cleanTime = s;
    if (cleanTime.includes("T")) {
      cleanTime = cleanTime.split("T")[1];
    } else if (cleanTime.includes(" ") && (cleanTime.includes("-") || cleanTime.includes("/"))) {
      const parts = cleanTime.split(/\s+/);
      cleanTime = parts.slice(1).join(" ");
    }

    const match = cleanTime.match(/(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?/i);
    if (!match) return { hh: "12", mm: "00", ap: "AM" };

    let h = parseInt(match[1], 10);
    let mm = match[2];
    let ap = match[3] ? match[3].toUpperCase() : null;

    if (!ap) {
      if (h >= 12) {
        ap = "PM";
        if (h > 12) h -= 12;
      } else {
        ap = "AM";
        if (h === 0) h = 12;
      }
    } else {
      if (h === 0) h = 12;
      else if (h > 12) {
        ap = "PM";
        h -= 12;
      }
    }

    let hh = String(h).padStart(2, "0");
    if (!TIME_HOURS.includes(hh)) hh = "12";
    if (!TIME_MINUTES.includes(mm)) {
      const nearest = TIME_MINUTES.reduce((prev, curr) =>
        Math.abs(Number(curr) - Number(mm)) < Math.abs(Number(prev) - Number(mm))
          ? curr
          : prev,
      );
      mm = nearest;
    }

    return { hh, mm, ap: ap || "AM" };
  };

  const TIME_HOURS = Array.from({ length: 12 }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
  const TIME_MINUTES = Array.from({ length: 12 }, (_, i) =>
    String(i * 5).padStart(2, "0")
  );

  const formatTimePartsToString = (parts) =>
    `${parts.hh}:${parts.mm} ${parts.ap}`;

  const renderTimePicker = (index, field, currentValue) => {
    const parts = parseTimeParts(currentValue);
    const update = (k, v) => {
      const updated = { ...parts, [k]: v };
      handleDateWiseChange(
        index,
        field,
        formatTimePartsToString(updated)
      );
    };
    const selectStyle = {
      border: "none",
      background: "transparent",
      fontSize: "12px",
      fontWeight: 600,
      color: "#0f172a",
      padding: "0 1px",
      cursor: "pointer",
      appearance: "none",
      WebkitAppearance: "none",
      textAlign: "center",
      outline: "none",
    };
    return (
      <div
        style={{
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "2px",
          border: "1px solid #cbd5e1",
          borderRadius: "6px",
          padding: "4px 6px",
          background: "#ffffff",
          width: "100%",
          boxSizing: "border-box",
          height: "34px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.03)",
        }}
      >
        <select
          value={parts.hh}
          onChange={(e) => update("hh", e.target.value)}
          disabled={isDutySlipReadOnly}
          style={{ ...selectStyle, width: "22px" }}
        >
          {TIME_HOURS.map((h) => (
            <option key={h} value={h}>
              {h}
            </option>
          ))}
        </select>
        <span style={{ fontSize: "12px", fontWeight: 700, color: "#64748b" }}>:</span>
        <select
          value={parts.mm}
          onChange={(e) => update("mm", e.target.value)}
          disabled={isDutySlipReadOnly}
          style={{ ...selectStyle, width: "22px" }}
        >
          {TIME_MINUTES.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
        <select
          value={parts.ap}
          onChange={(e) => update("ap", e.target.value)}
          disabled={isDutySlipReadOnly}
          style={{ ...selectStyle, width: "26px" }}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </select>
      </div>
    );
  };

  const parseDateTime = (dateStr, timeStr) => {
    if (!dateStr || !timeStr) return new Date(NaN);
    let year, month, day;
    const cleanDate = dateStr.trim().split(" ")[0].split("T")[0];
    if (cleanDate.includes("-")) {
      const parts = cleanDate.split("-");
      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else {
        [day, month, year] = parts;
      }
    } else if (cleanDate.includes("/")) {
      const parts = cleanDate.split("/");
      if (parts[0].length === 4) {
        [year, month, day] = parts;
      } else {
        [day, month, year] = parts;
      }
    } else {
      return new Date(cleanDate);
    }

    const [h, m, s] = timeStr.split(":");
    return new Date(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(h || 0),
      Number(m || 0),
      Number(s || 0)
    );
  };

  const calculateTotalTime = (openDate, openParts, closeDate, closeParts) => {
    if (!openDate || !closeDate) return;

    const openTime = buildTime24FromParts(openParts);
    const closeTime = buildTime24FromParts(closeParts);

    const open = parseDateTime(openDate, openTime);
    const close = parseDateTime(closeDate, closeTime);

    const diffMs = close - open;

    if (diffMs < 0 || isNaN(diffMs)) {
      setDutyslip((prev) => ({ ...prev, totalTime: "" }));
      return;
    }

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    setDutyslip((prev) => ({
      ...prev,
      totalTime: minutes > 0 ? `${hours}h ${minutes}m` : `${hours}h`,
    }));
  };

  // ===== Open Time
  const updateOpenTime = (key, value) => {
    const v = key === "ap" ? value : String(value).padStart(2, "0");

    setOpenTimeParts((prev) => {
      const updated = { ...prev, [key]: v };
      const timeStr = formatTimePartsToString(updated);
      setDutyslip((p) => ({ ...p, openTime: timeStr }));
      updateBoundaryDateWiseTime("open", timeStr);
      calculateTotalTime(
        dutyslip.openDate,
        updated,
        dutyslip.closeDate,
        closeTimeParts,
      );
      return updated;
    });
  };

  // ===== Close Time
  const updateCloseTime = (key, value) => {
    const v = key === "ap" ? value : String(value).padStart(2, "0");

    setCloseTimeParts((prev) => {
      const updated = { ...prev, [key]: v };
      const timeStr = formatTimePartsToString(updated);
      setDutyslip((p) => ({ ...p, closeTime: timeStr }));
      updateBoundaryDateWiseTime("close", timeStr);
      calculateTotalTime(
        dutyslip.openDate,
        openTimeParts,
        dutyslip.closeDate,
        updated,
      );
      return updated;
    });
  };

  const handleDutySlipChange = (e) => {
    const { name, value } = e.target;

    setDutyslip((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === "clientAddress" || name === "address") {
        updated.clientAddress = value;
        updated.address = value;
      }

      // ===== Recalculate totalTime & sync date-wise rows on date change
      if (name === "openDate" || name === "closeDate") {
        const newOpen = name === "openDate" ? value : updated.openDate;
        const newClose = name === "closeDate" ? value : updated.closeDate;
        calculateTotalTime(
          newOpen,
          openTimeParts,
          newClose,
          closeTimeParts
        );
        setDateWiseRows((prevRows) =>
          mergeDateWiseRows(
            newOpen,
            newClose,
            prevRows,
            {
              openingTime: openTimeParts
                ? formatTimePartsToString(openTimeParts)
                : "",
              closingTime: closeTimeParts
                ? formatTimePartsToString(closeTimeParts)
                : "",
            },
          ),
        );
      }

      // ===== Auto Total KM (Added)
      if (name === "kmStart" || name === "kmEnd") {
        const start = parseFloat(updated.kmStart) || 0;
        const end = parseFloat(updated.kmEnd) || 0;

        if (updated.kmEnd === "" || updated.kmStart === "") {
          updated.totalKm = "";
          setErrors((prev) => ({ ...prev, km: "" }));
        }
        else if (end < start) {
          updated.totalKm = "";
          setErrors((prev) => ({
            ...prev,
            km: "KM Close cannot be less than KM Start",
          }));
        }
        else {
          updated.totalKm = end - start;
          setErrors((prev) => ({ ...prev, km: "" }));
        }

        setDateWiseRows((prevRows) =>
          mergeDateWiseRows(updated.openDate, updated.closeDate, prevRows, {
            kmStart: updated.kmStart,
            kmEnd: updated.kmEnd,
            totalKm: updated.totalKm,
          }),
        );
      }

      return updated;
    });
  };

  const removeDateWiseRow = (index) => {
    setDateWiseRows((prevRows) => {
      const rows = normalizeDateWiseRows(prevRows);
      if (index !== rows.length - 1 || index === 0) return rows;
      const updatedRows = rows.filter((_, i) => i !== index);
      const summary = getRowsSummary(updatedRows);
      setDutyslip((prev) => ({
        ...prev,
        closeDate: updatedRows[updatedRows.length - 1]?.date || prev.closeDate,
        kmStart: summary.kmStart,
        kmEnd: summary.kmEnd,
        totalKm: summary.totalKm,
        totalTime: summary.totalTime,
      }));
      return updatedRows;
    });
  };

  const validateForm = () => {
    const missing = [];
    if (!dutyslip.clientName || !String(dutyslip.clientName).trim()) missing.push("Guest Name");
    if (!dutyslip.clientMobile || !String(dutyslip.clientMobile).trim()) missing.push("Guest Mobile");
    if (!dutyslip.vehicleType) missing.push("Vehicle Type");
    if (!dutyslip.driverName || !String(dutyslip.driverName).trim()) missing.push("Driver Name");
    if (!hasInputValue(dutyslip.kmStart)) missing.push("Starting KM");
    if (!hasInputValue(dutyslip.kmEnd)) missing.push("Closing KM");
    if (!hasInputValue(dutyslip.totalTime)) missing.push("Total Time");

    const hasPackage = dutyslip.fareId || dutyslip.package || (dateWiseRows && dateWiseRows.some((r) => r.fareId || r.FareId));
    if (!hasPackage) {
      missing.push("Package");
    }

    if (missing.length > 0) {
      showToast.warn(`${missing.join(", ")} ${missing.length === 1 ? "is" : "are"} required`);
      return false;
    }

    if (!/^\d{10}$/.test(dutyslip.clientMobile)) {
      showToast.warn("Enter valid 10 digit mobile");
      return false;
    }

    if (Number(dutyslip.kmEnd) < Number(dutyslip.kmStart)) {
      showToast.warn("KM Close cannot be less than KM Start");
      return false;
    }

    return true;
  };

  const validateBookingForm = () => {
    const missing = [];
    if (!booking.partyName) missing.push("Party Name");
    if (!booking.guestName || !String(booking.guestName).trim()) missing.push("Guest Name");
    if (!booking.mobile || !String(booking.mobile).trim()) missing.push("Mobile");
    if (!booking.vehicleType) missing.push("Vehicle Type");
    if (!booking.address || !String(booking.address).trim()) missing.push("Address");
    if (!booking.bookedBy || !String(booking.bookedBy).trim()) missing.push("Booked By");
    if (!booking.bookingDate) missing.push("Booking Date");
    if (!booking.endBookingDate) missing.push("End Booking Date");

    if (missing.length > 0) {
      showToast.warn(`${missing.join(", ")} ${missing.length === 1 ? "is" : "are"} required`);
      return false;
    }

    if (!/^\d{10}$/.test(booking.mobile)) {
      showToast.warn("Enter valid 10 digit mobile");
      return false;
    }

    return true;
  };

  const openDutySlipModal = async (booking) => {
    // Save selected booking
    setSelectedBooking(booking);

    // Clear errors
    setErrors({});

    if (booking.dutyslipId) {
      // If duty slip already exists, fetch it and display as read-only
      setIsDutySlipReadOnly(true);
      try {
        const res = await axios.get(`${BASE_API_URL}/dutyslip/dutyslip?id=${booking.dutyslipId}`);
        if (res.data?.success && res.data.data?.length > 0) {
          const ds = res.data.data[0];
          
          const savedRows = ds.dateWiseDetails?.length
            ? normalizeDateWiseRows(ds.dateWiseDetails)
            : [];
          const rangeStart = savedRows.length ? toInputDate(savedRows[0].date) : (toInputDate(ds.OpeningDate) || toInputDate(ds.DutyslipDate) || today);
          const rangeEnd = savedRows.length ? toInputDate(savedRows[savedRows.length - 1].date) : (toInputDate(ds.DutyslipEndDate) || rangeStart);

          const slipDate = toInputDate(ds.DutyslipDate) || rangeStart;
          const openDate = rangeStart;
          const closeDate = rangeEnd;

          const openParts = parseTimeParts(ds.openTime12 || ds.time12 || ds.time24 || ds.OpnTime || ds.openTime);
          const closeParts = parseTimeParts(ds.closeTime12 || ds.endTime12 || ds.endTime24 || ds.CloseTime || ds.closeTime);

          setOpenTimeParts(openParts);
          setCloseTimeParts(closeParts);

          setDutyslip({
            slipDate,
            openDate,
            closeDate,
            totalTime: ds.TotalTime ? `${ds.TotalTime}h` : "",
            partyName: ds.PartyName || booking.partyName || "",
            address: ds.PartyAddress || booking.address || "",
            clientName: ds.ClientName || booking.guestName || "",
            clientAddress: ds.ClientAddress || booking.address || "",
            clientMobile: ds.Mobile || booking.mobile || "",
            vehicleType: ds.VehicleType || booking.vehicleType || "",
            vehicleNo: ds.VehicleNo || booking.vehicleNo || "",
            acType: ds.CarType || "AC",
            driverName: ds.DriverName || "",
            kmStart: ds.KMStart ?? "",
            kmEnd: ds.KMClose ?? "",
            totalKm: ds.TotalKM ?? "",
            bookingId: booking.id || booking.BookingID || null,
          });

          const initialRows = mergeDateWiseRows(openDate, closeDate, savedRows, {
            kmStart: ds.KMStart ?? "",
            kmEnd: ds.KMClose ?? "",
            totalKm: ds.TotalKM ?? "",
            openingTime: formatTimePartsToString(openParts),
            closingTime: formatTimePartsToString(closeParts),
          });
          setDateWiseRows(initialRows);
          setSelectedPackageId(ds.FareId || ds.fareId || "");

          setShowDutySlipModal(true);
        } else {
          showToast.error("Failed to load duty slip details");
        }
      } catch (err) {
        console.error("Error loading duty slip:", err);
        showToast.error("Error loading duty slip details");
      }
    } else {
      // If no duty slip, prepare for generating one (editable mode)
      setIsDutySlipReadOnly(false);

      const openDate = toInputDate(booking.bookingDate) || today;
      const closeDate = toInputDate(booking.endBookingDate) || openDate;

      // Parse time parts from booking time/endTime
      const openParts = parseTimeParts(booking.time12 || booking.time);
      const closeParts = parseTimeParts(booking.endTime12 || booking.endTime);

      setOpenTimeParts(openParts);
      setCloseTimeParts(closeParts);

      // Fill DutySlip form with booking data
      setDutyslip({
        slipDate: today,

        partyName: booking.partyName || "",
        address: booking.address || "",
        clientName: booking.guestName || booking.clientName || "",
        clientAddress: booking.address || "",
        clientMobile: booking.mobile || "",

        vehicleType: booking.vehicleType || "",
        vehicleNo: booking.vehicleNo || "",
        acType: "AC",

        driverName: "",
        kmStart: "",
        kmEnd: "",
        totalKm: "",

        openDate,
        closeDate,

        totalTime: "",

        // ✅ IMPORTANT – BookingId set here
        bookingId: booking.id || booking.BookingID || null,
      });

      const initialRows = mergeDateWiseRows(openDate, closeDate, [], {
        openingTime: formatTimePartsToString(openParts),
        closingTime: formatTimePartsToString(closeParts),
      });
      setDateWiseRows(initialRows);

      // Open modal
      setShowDutySlipModal(true);
    }
  };

  const saveDutyslip = async () => {
    if (isSaving) return;
    if (!validateForm()) return;

    try {
      setIsSaving(true);

      const openTime = `${dutyslip.openDate} ${buildTime24FromParts(openTimeParts)}`;
      const closeTime = `${dutyslip.closeDate} ${buildTime24FromParts(closeTimeParts)}`;

      // ===== Current IST SlipDate (Added)
      const slipDate = getCurrentISTDateTime();

      const dateWisePayload = buildDateWisePayload();
      const rowSummary = getRowsSummary(dateWiseRows);
      const totalTimeFloat = rowSummary.totalTimeMinutes / 60;

      const payload = {
        slipDate,
        partyName: dutyslip.partyName,
        clientName: dutyslip.clientName,
        clientAddress: dutyslip.clientAddress || dutyslip.address || "",
        clientMobile: dutyslip.clientMobile,
        vehicleType: dutyslip.vehicleType,
        vehicleNo: dutyslip.vehicleNo || "",
        carType: dutyslip.acType || "AC",
        driverName: dutyslip.driverName,
        kmStart: Number(rowSummary.kmStart) || 0,
        kmEnd: Number(rowSummary.kmEnd) || 0,
        totalKm: Number(rowSummary.totalKm) || 0,
        openTime,
        closeTime,
        totalTime: totalTimeFloat,
        bookingId: dutyslip.bookingId || null,
        compId: selectedCompanyId,
        fareId: selectedPackageId || null,
        dateWiseDetails: dateWisePayload,
      };

      const res = await apiWithLog({
        method: "POST",
        url: `${BASE_API_URL}/dutyslip/create`,
        data: payload,
        module: "Generate DutySlip",
        action: "A",
      });

      if (res.data?.success) {
        showToast.save("Duty Slip saved successfully!");
        const newDutyslipId = res.data.id;
        
        // Update local bookingList state
        setBookingList((prevList) =>
          prevList.map((b) =>
            b.id === dutyslip.bookingId ? { ...b, dutyslipId: newDutyslipId } : b
          )
        );

        // Re-sync from the server so the persisted DutyslipID is confirmed
        fetchBookings(selectedCompanyId, selectedDate);

        // Switch to read-only view
        setIsDutySlipReadOnly(true);
      } else {
        showToast.error(res.data?.message || "Save failed");
      }
    } catch (err) {
      showToast.error("Server error");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="booking_container">

      {/* TOP BAR */}
      <div className="booking_top">
        <div className="booking_date_inline">
          <span className="booking_date_label">Booking Date</span>
          <input
            type="date"
            className="booking_date_input"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
          />
        </div>

        <button className="new_booking_btn" onClick={openNewBooking}>
          + New Booking
        </button>
      </div>

      {/* BOOKING LIST */}
      <div className="booking_list_section">
        <h6>Booking List</h6>

        <table className="booking_table">
          <thead>
            <tr>
              <th>Party</th>
              <th>Guest Name</th>
              <th>Guest Mobile No</th>
              <th>Vehicle</th>
              <th>Booked By</th>
              <th>Start Time</th>
              <th>End Date</th>
              <th>End Time</th>
              <th>Action</th>
            </tr>
          </thead>

          <tbody>
            {isLoadingBookings ? (
              <TableRowsSkeleton columns={9} rows={5} />
            ) : filteredBookings.length === 0 ? (
              <tr>
                <td colSpan="9" className="no_data">
                  No bookings found
                </td>
              </tr>
            ) : (
              paginatedBookings.map((b) => (
                <tr
                  key={b.id}
                  style={{
                    background: !b.dutyslipId ? "#fff7ed" : "inherit",
                    borderLeft: !b.dutyslipId ? "4px solid #f97316" : "none",
                  }}
                >
                  <td>{b.partyName}</td>
                  <td>{b.guestName}</td>
                  <td>{b.mobile}</td>
                  <td>{b.vehicleType}</td>
                  <td>{b.bookedBy}</td>
                  <td>{b.time12 || "-"}</td>
                  <td>{b.endBookingDate ? formatDisplayDate(b.endBookingDate) : "-"}</td>
                  <td>{b.endTime12 || "-"}</td>

                  <td className="action_cell">
                    <button
                      type="button"
                      className="action_btn edit_btn"
                      onClick={() => openEditBooking(b)}
                      title="Edit Booking"
                    >
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button
                      type="button"
                      className="action_btn delete_btn"
                      onClick={() => openDeleteModal(b)}
                      title="Delete Booking"
                    >
                      <i className="fa-solid fa-trash-can"></i>
                    </button>

                    <button
                      type="button"
                      className={`action_btn ${b.dutyslipId ? "view_duty_btn" : "gen_duty_btn"}`}
                      onClick={() => openDutySlipModal(b)}
                      title={b.dutyslipId ? "View Duty Slip (Generated)" : "Generate Duty Slip"}
                    >
                      <i className={b.dutyslipId ? "fa-solid fa-file-lines" : "fa-solid fa-plus"}></i>
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>

        {filteredBookings.length > 0 && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "12px 16px",
              background: "#fff",
              borderTop: "1px solid #e2e8f0",
              borderBottomLeftRadius: "8px",
              borderBottomRightRadius: "8px",
              fontSize: "13px",
              color: "#475569",
            }}
          >
            <div>
              Showing {startIndex + 1} to {Math.min(startIndex + itemsPerPage, filteredBookings.length)} of {filteredBookings.length} entries
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
              <button
                type="button"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: "5px 12px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  background: currentPage === 1 ? "#f1f5f9" : "#fff",
                  color: currentPage === 1 ? "#94a3b8" : "#334155",
                  cursor: currentPage === 1 ? "not-allowed" : "pointer",
                  fontWeight: 500,
                  fontSize: "13px",
                }}
              >
                Previous
              </button>
              <span style={{ fontWeight: 600, padding: "0 6px" }}>
                Page {currentPage} of {totalPages}
              </span>
              <button
                type="button"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage >= totalPages}
                style={{
                  padding: "5px 12px",
                  borderRadius: "6px",
                  border: "1px solid #cbd5e1",
                  background: currentPage >= totalPages ? "#f1f5f9" : "#fff",
                  color: currentPage >= totalPages ? "#94a3b8" : "#334155",
                  cursor: currentPage >= totalPages ? "not-allowed" : "pointer",
                  fontWeight: 500,
                  fontSize: "13px",
                }}
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>

      {/* ===== DELETE CONFIRM MODAL ===== */}
      <DeleteConfirmModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={confirmDeleteBooking}
        title="Delete Booking?"
        message="Are you sure you want to delete this booking record? This action cannot be undone."
        itemName={deleteItemName}
        loading={isDeleting}
      />

      {/* ================= ADD MODAL ================= */}
      {showAddModal && (
        <div className="booking_modal">
          <div className="booking_modal_content">
            <div className="modal_header">
              <h5>New Booking</h5>
              <span
                className="close_btn"
                onClick={() => setShowAddModal(false)}
              >
                ✕
              </span>
            </div>

            <div className="booking_form_scroll">
              {/* START */}
              <div className="booking_row">
                <div className="booking_input_div">
                  <label>Booking Start Date</label>
                  <input
                    type="date"
                    name="bookingDate"
                    value={booking.bookingDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="booking_input_div">
                  <label>Time</label>
                  <div className="time_ui">
                    <select
                      className="time_select"
                      value={timeParts.hh}
                      onChange={(e) => updateTime("hh", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i + 1).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <span className="time_colon">:</span>

                    <select
                      className="time_select"
                      value={timeParts.mm}
                      onChange={(e) => updateTime("mm", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i * 5).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      className="time_select ampm_select"
                      value={timeParts.ap}
                      onChange={(e) => updateTime("ap", e.target.value)}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* END */}
              <div className="booking_row">
                <div className="booking_input_div">
                  <label>Booking End Date</label>
                  <input
                    type="date"
                    name="endBookingDate"
                    value={booking.endBookingDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="booking_input_div">
                  <label>Time</label>
                  <div className="time_ui">
                    <select
                      className="time_select"
                      value={endTimeParts.hh}
                      onChange={(e) => updateEndTime("hh", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i + 1).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <span className="time_colon">:</span>

                    <select
                      className="time_select"
                      value={endTimeParts.mm}
                      onChange={(e) => updateEndTime("mm", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i * 5).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      className="time_select ampm_select"
                      value={endTimeParts.ap}
                      onChange={(e) => updateEndTime("ap", e.target.value)}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* PARTY */}
              <div className="booking_input_div">
                <label>Party Name</label>
                <SearchableSelect
                  options={parties.map((p) => ({ value: p.HEADName, label: p.HEADName }))}
                  value={booking.partyName}
                  onChange={(val) => handlePartySelect({ target: { value: val || "" } })}
                  placeholder="Select Party"
                  height="36px"
                />
              </div>

              <div className="booking_input_div">
                <label>Address</label>
                <textarea
                  rows="2"
                  name="address"
                  value={booking.address}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Guest Mobile No</label>
                <input
                  name="mobile"
                  value={booking.mobile}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Vehicle Type</label>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <SearchableSelect
                    options={allVehicleTypes}
                    value={booking.vehicleType}
                    onChange={(val) => {
                      setBooking((p) => ({ ...p, vehicleType: val || "", vehicleNo: "" }));
                    }}
                    placeholder="Select Type"
                    height="36px"
                  />
                  <button
                    type="button"
                    title="Add new vehicle type"
                    onClick={openAddVehicleTypeOnlyModal}
                    style={{
                      background: "#0d6efd",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "5px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: 1,
                      whiteSpace: "nowrap",
                      height: "36px",
                    }}
                  >
                    + Add
                  </button>
                </div>
              </div>

              <div className="booking_input_div">
                <label>Guest Name</label>
                <input
                  name="guestName"
                  value={booking.guestName}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Booked By</label>
                <input
                  name="bookedBy"
                  value={booking.bookedBy}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="modal_footer">
              <button
                className="booking_submit_btn"
                onClick={saveBooking}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save Booking"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* EDIT MODAL (same UI, uses updateBooking) */}
      {showEditModal && (
        <div className="booking_modal">
          <div className="booking_modal_content">
            <div className="modal_header">
              <h5>Edit Booking</h5>
              <span
                className="close_btn"
                onClick={() => setShowEditModal(false)}
              >
                ✕
              </span>
            </div>

            <div className="booking_form_scroll">
              {/* ================= START DATE & TIME ================= */}
              <div className="booking_row">
                <div className="booking_input_div">
                  <label>Booking Start Date</label>
                  <input
                    type="date"
                    name="bookingDate"
                    value={booking.bookingDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="booking_input_div">
                  <label>Time</label>
                  <div className="time_ui">
                    <select
                      className="time_select"
                      value={timeParts.hh}
                      onChange={(e) => updateTime("hh", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i + 1).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <span className="time_colon">:</span>

                    <select
                      className="time_select"
                      value={timeParts.mm}
                      onChange={(e) => updateTime("mm", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i * 5).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      className="time_select ampm_select"
                      value={timeParts.ap}
                      onChange={(e) => updateTime("ap", e.target.value)}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* ================= END DATE & TIME ================= */}
              <div className="booking_row">
                <div className="booking_input_div">
                  <label>Booking End Date</label>
                  <input
                    type="date"
                    name="endBookingDate"
                    value={booking.endBookingDate}
                    onChange={handleChange}
                  />
                </div>

                <div className="booking_input_div">
                  <label>Time</label>
                  <div className="time_ui">
                    <select
                      className="time_select"
                      value={endTimeParts.hh}
                      onChange={(e) => updateEndTime("hh", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i + 1).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <span className="time_colon">:</span>

                    <select
                      className="time_select"
                      value={endTimeParts.mm}
                      onChange={(e) => updateEndTime("mm", e.target.value)}
                    >
                      {Array.from({ length: 12 }, (_, i) => {
                        const val = String(i * 5).padStart(2, "0");
                        return (
                          <option key={val} value={val}>
                            {val}
                          </option>
                        );
                      })}
                    </select>

                    <select
                      className="time_select ampm_select"
                      value={endTimeParts.ap}
                      onChange={(e) => updateEndTime("ap", e.target.value)}
                    >
                      <option value="AM">AM</option>
                      <option value="PM">PM</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* ================= PARTY ================= */}
              <div className="booking_input_div">
                <label>Party Name</label>
                <SearchableSelect
                  options={parties.map((p) => ({ value: p.HEADName, label: p.HEADName }))}
                  value={booking.partyName}
                  onChange={(val) => handlePartySelect({ target: { value: val || "" } })}
                  placeholder="Select Party"
                  height="36px"
                />
              </div>

              <div className="booking_input_div">
                <label>Address</label>
                <textarea
                  rows="2"
                  name="address"
                  value={booking.address}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Guest Mobile No</label>
                <input
                  name="mobile"
                  value={booking.mobile}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Vehicle Type</label>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <SearchableSelect
                    options={allVehicleTypes}
                    value={booking.vehicleType}
                    onChange={(val) => {
                      setBooking((p) => ({ ...p, vehicleType: val || "", vehicleNo: "" }));
                    }}
                    placeholder="Select Type"
                    height="36px"
                  />
                  <button
                    type="button"
                    title="Add new vehicle type"
                    onClick={openAddVehicleTypeOnlyModal}
                    style={{
                      background: "#0d6efd",
                      color: "#fff",
                      border: "none",
                      borderRadius: "6px",
                      padding: "5px 10px",
                      cursor: "pointer",
                      fontWeight: "bold",
                      fontSize: "14px",
                      lineHeight: 1,
                      whiteSpace: "nowrap",
                      height: "36px",
                    }}
                  >
                    + Add
                  </button>
                </div>
              </div>

              <div className="booking_input_div">
                <label>Guest Name</label>
                <input
                  name="guestName"
                  value={booking.guestName}
                  onChange={handleChange}
                />
              </div>

              <div className="booking_input_div">
                <label>Booked By</label>
                <input
                  name="bookedBy"
                  value={booking.bookedBy}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className="modal_footer">
              <button
                className="booking_submit_btn"
                onClick={updateBooking}
                disabled={isSaving}
              >
                {isSaving ? "Saving..." : "Save Changes"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= DUTY SLIP MODAL ================= */}

      {showDutySlipModal && (
        <div className="dutyslip_modal">
          <div
            className="dutyslip_modal_content"
            style={{
              width: "96vw",
              maxWidth: "1500px",
              height: "90vh",
              maxHeight: "900px",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              boxSizing: "border-box",
            }}
          >
            <div
              className="modal_header"
              style={{ padding: "12px 24px", flexShrink: 0 }}
            >
              <h5>{isDutySlipReadOnly ? "View Duty Slip" : "Generate Duty Slip"}</h5>
              <span
                className="close_btn"
                onClick={() => setShowDutySlipModal(false)}
              >
                ✕
              </span>
            </div>

            <div
              className="dutyslip_form_scroll"
              style={{
                flex: 1,
                overflowY: "auto",
                padding: "12px 24px 8px",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "1fr 1fr",
                  gap: "12px 24px",
                  marginBottom: "8px",
                }}
              >
                {/* Row 1: Duty Slip Date & Party Name */}
                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Duty Slip Date
                  </label>
                  <input
                    type="date"
                    name="slipDate"
                    value={dutyslip.slipDate}
                    onChange={handleDutySlipChange}
                    disabled={isDutySlipReadOnly}
                    style={{ height: "36px" }}
                  />
                </div>

                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Party Name
                  </label>
                  <input
                    value={dutyslip.partyName}
                    readOnly
                    style={{ height: "36px" }}
                  />
                </div>

                {/* Row 2: Driver Name & Guest Name */}
                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Driver Name
                  </label>
                  <input
                    name="driverName"
                    value={dutyslip.driverName}
                    onChange={handleDutySlipChange}
                    readOnly={isDutySlipReadOnly}
                    placeholder="Enter driver name"
                    style={{ height: "36px" }}
                  />
                </div>

                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Guest Name
                  </label>
                  <input
                    name="clientName"
                    value={dutyslip.clientName}
                    onChange={handleDutySlipChange}
                    readOnly={isDutySlipReadOnly}
                    placeholder="Enter guest name"
                    style={{ height: "36px" }}
                  />
                </div>

                {/* Row 3: Guest Mobile & Address */}
                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Guest Mobile
                  </label>
                  <input
                    name="clientMobile"
                    value={dutyslip.clientMobile}
                    onChange={handleDutySlipChange}
                    readOnly={isDutySlipReadOnly}
                    placeholder="Enter mobile"
                    style={{ height: "36px" }}
                  />
                </div>

                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Address
                  </label>
                  <input
                    name="clientAddress"
                    value={dutyslip.clientAddress || dutyslip.address || ""}
                    onChange={handleDutySlipChange}
                    readOnly={isDutySlipReadOnly}
                    placeholder="Enter address"
                    style={{ height: "36px" }}
                  />
                </div>

                {/* Row 4: Vehicle Type & Vehicle Number */}
                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Vehicle Type
                  </label>
                  <SearchableSelect
                    options={allVehicleTypes}
                    value={dutyslip.vehicleType}
                    onChange={(val) => {
                      setDutyslip((p) => ({ ...p, vehicleType: val || "", vehicleNo: "" }));
                    }}
                    isDisabled={isDutySlipReadOnly}
                    placeholder="Select Type"
                    height="36px"
                  />
                </div>

                <div className="dutyslip_input_div" style={{ marginBottom: 0 }}>
                  <label style={{ fontSize: "13px", fontWeight: 500 }}>
                    Vehicle Number
                  </label>
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <SearchableSelect
                      options={(() => {
                        const filtered = vehicles.filter((v) =>
                          !dutyslip.vehicleType ||
                          (v.VehicleTypeName && v.VehicleTypeName.toLowerCase() === dutyslip.vehicleType.toLowerCase()) ||
                          (v.VehicleType && v.VehicleType.toLowerCase() === dutyslip.vehicleType.toLowerCase())
                        );
                        const hasCurrent = dutyslip.vehicleNo && filtered.some((v) => v.VehicleNo === dutyslip.vehicleNo);
                        const opts = [];
                        if (dutyslip.vehicleNo && !hasCurrent) {
                          opts.push({ value: dutyslip.vehicleNo, label: dutyslip.vehicleNo });
                        }
                        filtered.forEach((v) => {
                          opts.push({ value: v.VehicleNo, label: v.VehicleNo });
                        });
                        return opts;
                      })()}
                      value={dutyslip.vehicleNo || ""}
                      onChange={(val) => {
                        handleDutySlipChange({ target: { name: "vehicleNo", value: val || "" } });
                      }}
                      isDisabled={isDutySlipReadOnly || !dutyslip.vehicleType}
                      placeholder={dutyslip.vehicleType ? "Select Vehicle No" : "Select Type first"}
                      height="36px"
                    />
                    {!isDutySlipReadOnly && (
                      <button
                        type="button"
                        title="Add new vehicle number"
                        onClick={() => openAddVehicleModalForDutySlip(dutyslip.vehicleType)}
                        style={{
                          background: "#0d6efd",
                          color: "#fff",
                          border: "none",
                          borderRadius: "6px",
                          padding: "5px 10px",
                          cursor: "pointer",
                          fontWeight: "bold",
                          fontSize: "14px",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                          height: "36px",
                        }}
                      >
                        + Add
                      </button>
                    )}
                  </div>
                </div>

                {/* Row 5: Open & Close Date/Time (span both) */}
                <div
                  style={{ gridColumn: "1 / -1", display: "flex", gap: "24px" }}
                >
                  <div
                    className="dutyslip_input_div"
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <label style={{ fontSize: "13px", fontWeight: 500 }}>
                      Open Date & Time
                    </label>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="date"
                        name="openDate"
                        value={dutyslip.openDate}
                        onChange={handleDutySlipChange}
                        disabled={isDutySlipReadOnly}
                        style={{
                          width: "120px",
                          flex: "0 0 auto",
                          height: "36px",
                        }}
                      />
                      <div
                        className="time_ui"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <select
                          className="time_select"
                          value={openTimeParts.hh}
                          onChange={(e) => updateOpenTime("hh", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          {TIME_HOURS.map((v) => (
                            <option key={v}>{v}</option>
                          ))}
                        </select>
                        <span className="time_colon">:</span>
                        <select
                          className="time_select"
                          value={openTimeParts.mm}
                          onChange={(e) => updateOpenTime("mm", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          {TIME_MINUTES.map((v) => (
                            <option key={v}>{v}</option>
                          ))}
                        </select>
                        <select
                          className="time_select ampm_select"
                          value={openTimeParts.ap}
                          onChange={(e) => updateOpenTime("ap", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          <option>AM</option>
                          <option>PM</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div
                    className="dutyslip_input_div"
                    style={{ flex: 1, marginBottom: 0 }}
                  >
                    <label style={{ fontSize: "13px", fontWeight: 500 }}>
                      Close Date & Time
                    </label>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="date"
                        name="closeDate"
                        value={dutyslip.closeDate}
                        onChange={handleDutySlipChange}
                        disabled={isDutySlipReadOnly}
                        style={{
                          width: "120px",
                          flex: "0 0 auto",
                          height: "36px",
                        }}
                      />
                      <div
                        className="time_ui"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <select
                          className="time_select"
                          value={closeTimeParts.hh}
                          onChange={(e) => updateCloseTime("hh", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          {TIME_HOURS.map((v) => (
                            <option key={v}>{v}</option>
                          ))}
                        </select>
                        <span className="time_colon">:</span>
                        <select
                          className="time_select"
                          value={closeTimeParts.mm}
                          onChange={(e) => updateCloseTime("mm", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          {TIME_MINUTES.map((v) => (
                            <option key={v}>{v}</option>
                          ))}
                        </select>
                        <select
                          className="time_select ampm_select"
                          value={closeTimeParts.ap}
                          onChange={(e) => updateCloseTime("ap", e.target.value)}
                          disabled={isDutySlipReadOnly}
                          style={{ height: "36px" }}
                        >
                          <option>AM</option>
                          <option>PM</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* ================= DATE WISE TRIP DETAILS TABLE ================= */}
              <div className="datewise_section" style={{ marginTop: "16px", marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                  <span style={{ width: "4px", height: "16px", background: "#0d9488", borderRadius: "2px" }} />
                  <span style={{ fontSize: "15px", fontWeight: 700, color: "#0f172a" }}>Date Wise Trip Details</span>
                </div>
                <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "8px", boxShadow: "0 2px 8px rgba(0,0,0,0.03)" }}>
                  <table style={{ borderCollapse: "collapse", width: "100%", fontSize: "12px" }}>
                    <thead>
                      <tr style={{ background: "#f8fafc", borderBottom: "2px solid #e2e8f0" }}>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Date</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>KM Start</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>KM Close</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Total KM</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Opening Time</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Closing Time</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Total Time</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", whiteSpace: "nowrap" }}>Trip Details</th>
                        <th style={{ padding: "10px 8px", fontSize: "11px", fontWeight: 700, color: "#475569", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center", minWidth: "140px", whiteSpace: "nowrap" }}>Package</th>
                        <th style={{ padding: "10px 8px", width: "30px" }}></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dateWiseRows.map((row, index) => {
                        const isLastRow = index === dateWiseRows.length - 1;
                        return (
                          <tr key={`${row.date}-${index}`} style={{ background: index % 2 === 1 ? "#f8fafc" : "#ffffff" }}>
                            <td style={{ padding: "6px", textAlign: "center" }}>
                              <div style={{ fontWeight: 700, fontSize: "12px", color: "#1d4ed8", background: "#eff6ff", border: "1px solid #dbeafe", borderRadius: "6px", padding: "5px 8px", whiteSpace: "nowrap" }}>
                                {formatDisplayDate(row.date)}
                              </div>
                            </td>
                            <td style={{ padding: "6px" }}>
                              <input
                                type="number"
                                value={row.kmStartUser}
                                onChange={(e) => handleDateWiseChange(index, "kmStartUser", e.target.value)}
                                disabled={isDutySlipReadOnly}
                                style={{ width: "100%", padding: "5px 8px", height: "34px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "12px", fontWeight: "500", textAlign: "center", boxSizing: "border-box" }}
                              />
                            </td>
                            <td style={{ padding: "6px" }}>
                              <input
                                type="number"
                                value={row.kmClose}
                                onChange={(e) => handleDateWiseChange(index, "kmClose", e.target.value)}
                                disabled={isDutySlipReadOnly}
                                style={{ width: "100%", padding: "5px 8px", height: "34px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "12px", fontWeight: "500", textAlign: "center", boxSizing: "border-box" }}
                              />
                            </td>
                            <td style={{ padding: "6px" }}>
                              <input
                                type="number"
                                value={row.totalKm}
                                onChange={(e) => handleDateWiseChange(index, "totalKm", e.target.value)}
                                disabled={isDutySlipReadOnly}
                                style={{ width: "100%", padding: "5px 8px", height: "34px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "12px", fontWeight: 700, color: "#047857", background: "#f0fdf4", textAlign: "center", boxSizing: "border-box" }}
                              />
                            </td>
                            <td style={{ padding: "6px" }}>
                              {renderTimePicker(index, "openingTime", row.openingTime)}
                            </td>
                            <td style={{ padding: "6px" }}>
                              {renderTimePicker(index, "closingTime", row.closingTime)}
                            </td>
                            <td style={{ padding: "6px" }}>
                              <input
                                type="text"
                                value={row.totalTime || ""}
                                onChange={(e) => handleDateWiseChange(index, "totalTime", e.target.value)}
                                disabled={isDutySlipReadOnly}
                                placeholder="0"
                                style={{
                                  width: "100%",
                                  padding: "5px 8px",
                                  height: "34px",
                                  borderRadius: "6px",
                                  border: "1px solid #cbd5e1",
                                  fontSize: "12px",
                                  fontWeight: 700,
                                  color: row.totalTime ? "#047857" : "#94a3b8",
                                  background: row.totalTime ? "#ecfdf5" : "#ffffff",
                                  textAlign: "center",
                                  boxSizing: "border-box",
                                }}
                              />
                            </td>
                            <td style={{ padding: "6px" }}>
                              <input
                                type="text"
                                value={row.tripDetails}
                                onChange={(e) => handleDateWiseChange(index, "tripDetails", e.target.value)}
                                disabled={isDutySlipReadOnly}
                                style={{ width: "100%", padding: "5px 8px", height: "34px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "12px", fontWeight: "500", boxSizing: "border-box" }}
                              />
                            </td>
                            <td style={{ padding: "6px" }}>
                              <select
                                value={row.fareId || selectedPackageId || ""}
                                onChange={(e) => {
                                  const selectedId = e.target.value;
                                  const selected = (packages || []).find((p) => p && String(p.ID) === String(selectedId));
                                  const rawPkgName = String(selected?.PackageName || "").trim();
                                  handleDateWiseChange(index, "fareId", selectedId);
                                  handleDateWiseChange(index, "packageName", rawPkgName);
                                  setSelectedPackageId(selectedId);
                                }}
                                disabled={isDutySlipReadOnly}
                                style={{ width: "100%", padding: "5px 8px", height: "34px", borderRadius: "6px", border: "1px solid #cbd5e1", fontSize: "12px", fontWeight: "500", boxSizing: "border-box" }}
                              >
                                <option value="">-- Select Package --</option>
                                {Array.from(
                                  new Map(
                                    (packages || [])
                                      .filter((p) => p && p.PackageName)
                                      .map((p) => [String(p.PackageName).trim().toLowerCase(), p])
                                  ).values()
                                ).map((p) => {
                                  const pkgName = String(p.PackageName || "").trim();
                                  return (
                                    <option key={p.ID || Math.random()} value={p.ID}>
                                      {pkgName || "-- Package --"}
                                    </option>
                                  );
                                })}
                              </select>
                            </td>
                            <td style={{ padding: "6px", textAlign: "center" }}>
                              {!isDutySlipReadOnly && isLastRow && index > 0 && (
                                <button
                                  type="button"
                                  onClick={() => removeDateWiseRow(index)}
                                  title="Remove this date row"
                                  style={{
                                    width: "24px",
                                    height: "24px",
                                    lineHeight: "22px",
                                    borderRadius: "50%",
                                    border: "1px solid #fecaca",
                                    background: "#fef2f2",
                                    color: "#ef4444",
                                    fontWeight: 700,
                                    fontSize: "12px",
                                    cursor: "pointer",
                                    padding: 0,
                                    display: "inline-flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    transition: "all 0.15s ease",
                                  }}
                                >
                                  ✕
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                    <tfoot>
                      <tr style={{ background: "#f8fafc", borderTop: "2px solid #e2e8f0" }}>
                        <td
                          colSpan={5}
                          style={{
                            padding: "10px 12px",
                            textAlign: "right",
                            fontWeight: 700,
                            fontSize: "12.5px",
                            color: "#0f172a",
                          }}
                        >
                          Grand Total
                        </td>
                        <td
                          style={{
                            padding: "10px 6px",
                            textAlign: "center",
                            fontWeight: 700,
                            fontSize: "12.5px",
                            color: "#0f172a",
                          }}
                        >
                          {dutyslip.totalKm || 0}
                        </td>
                        <td colSpan={2} style={{ padding: "10px 6px" }}></td>
                        <td
                          style={{
                            padding: "10px 6px",
                            textAlign: "center",
                            fontWeight: 700,
                            fontSize: "12.5px",
                            color: "#0f172a",
                          }}
                        >
                          {dutyslip.totalTime !== "" && dutyslip.totalTime !== undefined && dutyslip.totalTime !== null ? dutyslip.totalTime : "0h"}
                        </td>
                        <td colSpan={2} style={{ padding: "10px 6px" }}></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

            {/* Sticky Footer */}
            <div
              className="modal_footer"
              style={{
                padding: "8px 24px",
                background: "#fff",
                borderTop: "1px solid #e2e8f0",
                flexShrink: 0,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <button
                type="button"
                onClick={addDateWiseRow}
                disabled={isDutySlipReadOnly}
                style={{
                  padding: "4px 14px",
                  fontSize: "12px",
                  fontWeight: 600,
                  color: "#0f766e",
                  background: "#ecfdf5",
                  border: "1px solid #99f6e4",
                  borderRadius: "6px",
                  cursor: "pointer",
                  height: "32px",
                }}
              >
                + Add Date Row
              </button>

              {isDutySlipReadOnly ? (
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <button
                    type="button"
                    style={{
                      padding: "0 16px",
                      height: "36px",
                      background: "#0d6efd",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() => setIsDutySlipReadOnly(false)}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    style={{
                      padding: "0 16px",
                      height: "36px",
                      background: "#6c757d",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                    onClick={() => setShowDutySlipModal(false)}
                  >
                    Close
                  </button>
                </div>
              ) : (
                <button
                  className="dutyslip_submit_btn"
                  onClick={saveDutyslip}
                  disabled={isSaving}
                  style={{
                    width: "auto",
                    height: "36px",
                    padding: "0 16px",
                    background: "#0f766e",
                    color: "#fff",
                    border: "none",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: 600,
                    cursor: "pointer",
                    transition: "background 0.2s",
                    whiteSpace: "nowrap",
                  }}
                  onMouseEnter={(e) => (e.target.style.background = "#0d5e57")}
                  onMouseLeave={(e) => (e.target.style.background = "#0f766e")}
                >
                  {isSaving ? "Saving..." : "Save Duty Slip"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ================= ADD VEHICLE MINI-MODAL ================= */}
      {showAddVehicleModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.55)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "28px 32px",
              width: "100%",
              maxWidth: "460px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: "17px", color: "#1e293b" }}>
                🚗 Add New Vehicle
              </h5>
              <span
                onClick={() => setShowAddVehicleModal(false)}
                style={{ cursor: "pointer", fontSize: "20px", color: "#64748b", lineHeight: 1 }}
              >
                ✕
              </span>
            </div>

            {/* Vehicle Type Name */}
            <div style={{ marginBottom: "14px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "5px" }}
              >
                Vehicle Type Name *
              </label>
              <select
                value={newVehicleForm.isCustomType ? "__NEW__" : newVehicleForm.vtypeName}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "__NEW__") {
                    setNewVehicleForm((p) => ({ ...p, vtypeName: "", isCustomType: true }));
                  } else {
                    setNewVehicleForm((p) => ({ ...p, vtypeName: val, isCustomType: false }));
                  }
                }}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                  background: "#fff",
                  marginBottom: newVehicleForm.isCustomType ? "8px" : "0",
                }}
              >
                <option value="">Select Vehicle Type</option>
                {allVehicleTypes.map((vt) => (
                  <option key={vt} value={vt}>
                    {vt}
                  </option>
                ))}
                <option value="__NEW__">+ Add New Vehicle Type...</option>
              </select>

              {newVehicleForm.isCustomType && (
                <input
                  type="text"
                  placeholder="Enter new vehicle type name..."
                  value={newVehicleForm.vtypeName}
                  onChange={(e) =>
                    setNewVehicleForm((p) => ({ ...p, vtypeName: e.target.value }))
                  }
                  style={{
                    width: "100%",
                    padding: "9px 12px",
                    border: "1.5px solid #e2e8f0",
                    borderRadius: "8px",
                    fontSize: "14px",
                    outline: "none",
                    boxSizing: "border-box",
                  }}
                />
              )}
            </div>

            {/* Vehicle Number */}
            <div style={{ marginBottom: "14px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "5px" }}
              >
                Vehicle Number *
              </label>
              <input
                type="text"
                placeholder="e.g. MH01AB1234"
                value={newVehicleForm.vehicleNumber}
                onChange={(e) =>
                  setNewVehicleForm((p) => ({ ...p, vehicleNumber: e.target.value }))
                }
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Ownership */}
            <div style={{ marginBottom: "14px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "5px" }}
              >
                Ownership <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  background: "#f1f5f9",
                  padding: "3px",
                  borderRadius: "8px",
                  border: "1.5px solid #e2e8f0",
                  height: "40px",
                  boxSizing: "border-box",
                  width: "100%",
                }}
              >
                <button
                  type="button"
                  onClick={() => setNewVehicleForm((p) => ({ ...p, self: 1 }))}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: (newVehicleForm.self === 1 || newVehicleForm.self === "1") ? "700" : "500",
                    backgroundColor: (newVehicleForm.self === 1 || newVehicleForm.self === "1") ? "#0f766e" : "transparent",
                    color: (newVehicleForm.self === 1 || newVehicleForm.self === "1") ? "#ffffff" : "#475569",
                    boxShadow: (newVehicleForm.self === 1 || newVehicleForm.self === "1") ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-car" style={{ fontSize: "12px" }}></i> Self
                </button>
                <button
                  type="button"
                  onClick={() => setNewVehicleForm((p) => ({ ...p, self: 0 }))}
                  style={{
                    flex: 1,
                    height: "100%",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                    fontSize: "13px",
                    fontWeight: (newVehicleForm.self === 0 || newVehicleForm.self === "0" || newVehicleForm.self == null) ? "700" : "500",
                    backgroundColor: (newVehicleForm.self === 0 || newVehicleForm.self === "0" || newVehicleForm.self == null) ? "#0f766e" : "transparent",
                    color: (newVehicleForm.self === 0 || newVehicleForm.self === "0" || newVehicleForm.self == null) ? "#ffffff" : "#475569",
                    boxShadow: (newVehicleForm.self === 0 || newVehicleForm.self === "0" || newVehicleForm.self == null) ? "0 1px 3px rgba(0,0,0,0.12)" : "none",
                    transition: "all 0.15s ease",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                >
                  <i className="fa-solid fa-users" style={{ fontSize: "12px" }}></i> Others
                </button>
              </div>
            </div>

            {/* Owner */}
            <div style={{ marginBottom: "14px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "5px" }}
              >
                Owner <span style={{ color: "#ef4444" }}>*</span>
              </label>
              <select
                value={newVehicleForm.ownerID}
                onChange={(e) =>
                  setNewVehicleForm((p) => ({ ...p, ownerID: e.target.value }))
                }
                required
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                  background: "#fff",
                }}
              >
                <option value="">Select Owner (Sundry Creditor) *</option>
                {ownersList.map((o) => (
                  <option key={o.HEAD_CODE} value={o.HEAD_CODE}>
                    {o.OwnerName}
                  </option>
                ))}
              </select>
            </div>

            {/* Model Year */}
            <div style={{ marginBottom: "22px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "5px" }}
              >
                Model Year
              </label>
              <input
                type="number"
                min="1990"
                max="2099"
                placeholder="e.g. 2026 (Optional)"
                value={newVehicleForm.modelYear}
                onChange={(e) =>
                  setNewVehicleForm((p) => ({ ...p, modelYear: e.target.value }))
                }
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            {/* Action buttons */}
            <div style={{ display: "flex", gap: "12px", justifyContent: "flex-end" }}>
              <button
                type="button"
                onClick={() => setShowAddVehicleModal(false)}
                disabled={isAddingVehicle}
                style={{
                  padding: "9px 22px",
                  borderRadius: "8px",
                  border: "1.5px solid #e2e8f0",
                  background: "#f8fafc",
                  color: "#374151",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleAddVehicleSubmit}
                disabled={isAddingVehicle}
                style={{
                  padding: "9px 22px",
                  borderRadius: "8px",
                  border: "none",
                  background: isAddingVehicle ? "#93c5fd" : "#0d6efd",
                  color: "#fff",
                  fontWeight: 700,
                  cursor: isAddingVehicle ? "not-allowed" : "pointer",
                  fontSize: "14px",
                }}
              >
                {isAddingVehicle ? "Saving…" : "Save Vehicle"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ================= ADD VEHICLE TYPE ONLY MODAL ================= */}
      {showAddVehicleTypeOnlyModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0, 0, 0, 0.55)",
            backdropFilter: "blur(4px)",
            zIndex: 99999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: "14px",
              padding: "28px 32px",
              width: "100%",
              maxWidth: "400px",
              boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
              position: "relative",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "20px",
              }}
            >
              <h5 style={{ margin: 0, fontWeight: 700, fontSize: "17px", color: "#1e293b" }}>
                🚙 Add New Vehicle Type
              </h5>
              <span
                onClick={() => setShowAddVehicleTypeOnlyModal(false)}
                style={{ cursor: "pointer", fontSize: "20px", color: "#64748b", lineHeight: 1 }}
              >
                ✕
              </span>
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{ display: "block", fontSize: "13px", fontWeight: 600, color: "#374151", marginBottom: "6px" }}
              >
                Vehicle Type Name *
              </label>
              <input
                type="text"
                placeholder="e.g. SUV, SEDAN, BUS..."
                value={newVehicleTypeNameInput}
                onChange={(e) => setNewVehicleTypeNameInput(e.target.value)}
                style={{
                  width: "100%",
                  padding: "9px 12px",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: "8px",
                  fontSize: "14px",
                  outline: "none",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
              <button
                type="button"
                onClick={() => setShowAddVehicleTypeOnlyModal(false)}
                style={{
                  padding: "8px 16px",
                  borderRadius: "8px",
                  border: "1.5px solid #cbd5e1",
                  background: "#fff",
                  color: "#475569",
                  fontWeight: 600,
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={handleAddVehicleTypeOnlySubmit}
                disabled={isSavingVehicleTypeOnly}
                style={{
                  padding: "8px 20px",
                  borderRadius: "8px",
                  border: "none",
                  background: isSavingVehicleTypeOnly ? "#93c5fd" : "#0d6efd",
                  color: "#fff",
                  fontWeight: 600,
                  cursor: isSavingVehicleTypeOnly ? "not-allowed" : "pointer",
                  fontSize: "14px",
                }}
              >
                {isSavingVehicleTypeOnly ? "Saving…" : "Save Type"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Booking;